import {
  AfterViewChecked,
  booleanAttribute,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ICityDto } from '@models/city-dto';
import { ICountryDto } from '@models/country-dto';
import { AcceptTypesEnum } from '@models/enums/accept-types-enum';
import { AttachmentExtensionEnum } from '@models/enums/attachment-extension-enum';
import { AttachmentTypeEnum } from '@models/enums/attachment-type-enum';
import { BloodTypeEnum } from '@models/enums/blood-type-enum';
import { DegreeOfRelationshipEnum } from '@models/enums/degree-of-relationship-enum';
import { DocumentTypeEnum } from '@models/enums/document-type-enum';
import { DominantHandEnum } from '@models/enums/dominant-hand-enum';
import { GenreEnum } from '@models/enums/genre-enum';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { IEventDto } from '@models/event-dto';
import { EventFilter } from '@models/events/event-filter';
import { IEventValidationsDto } from '@models/events/dto/event-validations-dto';
import { AttachmentSphere } from '@models/events/enums/attachment-sphere-enum';
import { BodyErrorDto } from '@models/exceptions/body-error-dto';
import { ResponseDto } from '@models/exceptions/response-dto';
import { IFederationBasicDataDto } from '@models/federation-basic-data';
import { TeachingInstitutionFilter } from '@models/institution/teaching-institution-filter';
import { IPage } from '@models/pagination/page';
import { PageRequest } from '@models/pagination/page-request';
import { IAddressDto } from '@models/portal/users/dtos/address-dto';
import { IAttachmentDto } from '@models/portal/users/dtos/attachment-dto';
import { IAttachmentTypeDto } from '@models/portal/users/dtos/attchment-type-dto';
import { IContactDto } from '@models/portal/users/dtos/contact-dto';
import { IDocumentDto } from '@models/portal/users/dtos/document-dto';
import { IUserDto } from '@models/portal/users/dtos/user-dto';
import {
  ContaBancariaDto,
  IUserRelationshipDto,
} from '@models/portal/users/dtos/user-relationship-dto';
import { IUserResponsibleDto } from '@models/portal/users/dtos/user-responsible-dto';
import { AddressForm } from '@models/portal/users/forms/address-form';
import { AttachmentForm } from '@models/portal/users/forms/attachment-form';
import { ContactForm } from '@models/portal/users/forms/contact-form';
import { DocumentForm } from '@models/portal/users/forms/document-form';
import { UserForm } from '@models/portal/users/forms/user-form';
import {
  ContaBancariaForm,
  UserRelationshipForm,
} from '@models/portal/users/forms/user-relationship-form';
import { UserResponsibleForm } from '@models/portal/users/forms/user-responsible-form';
import { UseTermsForm } from '@models/portal/users/forms/user-terms-form';
import { IUserFieldsValidatorDto } from '@models/portal/validator/dto/user-fields-validator-dto';
import { ContaBancariaEnum } from '@models/portal/validator/enums/conta-bancaria-fields-enum';
import { UserBasicDataEnum } from '@models/portal/validator/enums/user-field-enum';
import { IUserFieldsValidatorFilter } from '@models/portal/validator/filters/user-fields-validator-filter';
import { IPositionDto } from '@models/position-dto';
import { IStateDto } from '@models/state-dto';
import { ITeachingInstitutionDto } from '@models/teaching-institution-dto';
import { IViaCepEntityDto } from '@models/via-cep-entity-dto';
import { InputTypeEnum } from '@shared/components/input-container/input-container.component';
import { notNull } from '@shared/rxjs/custom-rxjs-operators';
import {
  AgenciaService,
  IAgenciaDto,
  IAgenciaFilter,
} from '@shared/services/agencia.service';
import { AttachmentService } from '@shared/services/attachment.service';
import { AuthService } from '@shared/services/auth.service';
import { BancoDto, BancoService } from '@shared/services/banco.service';
import { CityService } from '@shared/services/city.service';
import {
  ConfirmationModalService,
  ConfirmationModalType,
} from '@shared/services/confirmation-modal.service';
import { CountryService } from '@shared/services/country.service';
import { EventService } from '@shared/services/event.service';
import { FederationService } from '@shared/services/federation.service';
import { LoadingService } from '@shared/services/loading.service';
import { AttachmentTypeService } from '@shared/services/portal/attachment-type.service';
import { UserValidatorFieldsService } from '@shared/services/portal/user-validator-fields.service';
import { UserService } from '@shared/services/portal/user.service';
import { PositionService } from '@shared/services/position.service';
import { SnackbarService } from '@shared/services/snackbar.service';
import { StateService } from '@shared/services/state.service';
import { TeachingInstitutionService } from '@shared/services/teaching-institution.service';
import {
  IUseTermDto,
  TermTypeEnum,
  UseTermsService,
} from '@shared/services/use-terms.service';
import { ViaCepService } from '@shared/services/via-cep.service';
import { ControlsOf } from '@shared/types/form-group-of';
import { ParamsForList } from '@shared/types/params-for-list';
import { NgxPhotoEditorService } from 'ngx-photo-editor';
import {
  BehaviorSubject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  filter,
  map,
  Observable,
  of,
  skip,
  Subject,
  switchMap,
  takeUntil,
  tap,
  throwError,
} from 'rxjs';
import { HandlerErrorMessage } from 'src/app/core/utilities/handler-error-message';
import { ParamsSubjectBuilder } from 'src/app/core/utilities/params-subject-builder';
import { regex } from 'src/app/core/utilities/regex';
import { enumToDropdownOptions } from 'src/app/core/utilities/utility-functions';
import { Utils } from 'src/app/core/utilities/utils';
import { ContactTypeEnum } from './../../../models/enums/contact-type-enum';
import { IPageable } from './../../../models/pagination/pageable';
import { TipoContaBancariaEnum } from './../../../models/portal/users/forms/user-relationship-form';
import { IBancoFilter } from './../../../shared/services/banco.service';
import {
  DocumentVaildationService,
  TipoCampoValidacaoEnum,
  ValidadorDocumentosEhContatosDto,
} from './../../../shared/services/document-vaildation.service';
import { UserFormApiErrorService } from './api-error';
import { attachments, AttachmentView, documents } from './form-resources';
import {
  userAddressFieldReference,
  userBasicDataFieldReference,
} from './requitred-fields-config';
import { formArrayChildrenValidator } from './validators/form-array-children-validator';
import { minimumResponsibleValidator } from './validators/user-responsible-minimum-validator';
import {
  verifyAddressChanges,
  verifyBasicDataChanges,
  verifyContaBancariaChanges,
  verifyContactsChanges,
  verifyDocumentsChanges,
  verifyResponsibleChanges,
} from './verify-changes';
import { IFederationDto } from '@models/federation-dto';

export enum UserFormStep {
  BasicData = 0,
  Address = 1,
  Contacts = 2,
  Documents = 3,
  Attachments = 4,
}

export enum UserStepValidationEnum {
  LOGRADOURO = 'LOGRADOURO',
  USUARIO = 'USUARIO',
  DOCUMENTO = 'DOCUMENTO',
  ANEXO = 'ANEXO',
  CONTATO = 'CONTATO',
}

export interface UserExternalEdit {
  eveNrId: number;
  usuNrId: number;
  externalTypeEdit: UserType;
}

export enum UserType {
  'Dirigente' = 'DIRIGENTE',
  'Colaborador' = 'COLABORADOR',
  'Comissão Técnica' = 'COMISSAO_TECNICA',
  'Responsável' = 'RESPONSAVEL',
  'Atleta' = 'ATLETA',
}

export type UserFormRequests =
  | 'dados_basicos'
  | 'endereco'
  | 'contatos'
  | 'documentos'
  | 'anexos';

export type UserResponsibleViewFg = ControlsOf<UserResponsibleForm> &
  ControlsOf<{ usuTxNome: string }>;
export type AttachmentViewFg = ControlsOf<AttachmentForm> &
  ControlsOf<{ label: string; accepts: AcceptTypesEnum }>;
export type DocumentViewFg = ControlsOf<DocumentForm> &
  ControlsOf<{ label: string; mask: string; placeholder: string }>;
export type UserWithoutGuardian = Omit<UserForm, 'usuListResponsavel'>;

@Component({
  selector: 'sigecom-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
})

//Boa sorte nobre jovem que está prestes a dar manutenção nessa coisa enorme
export class UserFormComponent implements OnInit, OnDestroy, AfterViewChecked {
  unsubscribe$ = new Subject<void>();

  fb = inject(FormBuilder);
  bancoService = inject(BancoService);
  agenciaService = inject(AgenciaService);

  private setUserTypeFormValue(isColaborador?: boolean): void {
    const tipoFuncaoControl =
      this.userForm.controls.basicData.controls.tipoFuncao;
    if (isColaborador) tipoFuncaoControl.setValue('COLABORADOR');
    else tipoFuncaoControl.setValue(null);
  }

  userForm = this.fb.group(
    {
      basicData: this.fb.group<ControlsOf<UserWithoutGuardian>>({
        usuTxNome: this.fb.control(null, [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
        ]),
        usuTxCodigoInep: this.fb.control(null, [
          Validators.minLength(12),
          Validators.maxLength(12),
        ]),
        fedNrId: this.fb.control(null, Validators.required),
        insNrId: this.fb.control(null),
        tipoFuncao: this.fb.control(null),
        carNrId: this.fb.control(null),
        usuBlAuxilioBrasil: this.fb.control(false),
        usuDtNascimento: this.fb.control(null, [
          Validators.required,
          this.maxDateValidator(new Date(this.getToday())),
        ]),
        usuNrAltura: this.fb.control(null, Validators.min(0.1)),
        usuNrPeso: this.fb.control(null, Validators.min(0.1)),
        usuTxSexo: this.fb.control(null),
        usuTxTipoSanguineo: this.fb.control(null),
        usuTxLadoDominante: this.fb.control(null),
        entTxMetadado: this.fb.control(null),
        entNrId: this.fb.control(null),
      }),
      termoUsoForm: this.fb.group<ControlsOf<UseTermsForm>>({
        terNrId: this.fb.control(1),
        usuBlTermoDeUso: this.fb.control(null, Validators.requiredTrue),
      }),
      address: this.fb.group<ControlsOf<AddressForm>>({
        logTxCep: this.fb.control(null, [
          Validators.minLength(8),
          Validators.maxLength(9),
        ]),
        logTxBairro: this.fb.control(null),
        logTxLogradouro: this.fb.control(null, [
          Validators.maxLength(200),
          this.noWhitespaceValidator(),
        ]),
        logTxComplemento: this.fb.control(null),
        logNrNumero: this.fb.control(null),
        cidNrId: this.fb.control(
          { value: null, disabled: true },
          Validators.required,
        ),
        estNrId: this.fb.control(
          { value: null, disabled: true },
          Validators.required,
        ),
        paiNrId: this.fb.control(null, Validators.required),
        entTxMetadado: this.fb.control(null),
        entNrId: this.fb.control(null),
      }),
      responsibles: this.fb.array<FormGroup<UserResponsibleViewFg>>([]),
      contacts: this.fb.array<FormGroup<ControlsOf<ContactForm>>>(
        [],
        formArrayChildrenValidator(),
      ),
      documents: this.fb.array<FormGroup<DocumentViewFg>>(
        [],
        formArrayChildrenValidator(),
      ),
      attachments: this.fb.array<FormGroup<AttachmentViewFg>>([]),
      contaBancariaForm: this.fb.group<ControlsOf<ContaBancariaForm>>({
        banNrId: this.fb.control(null),
        ageNrId: this.fb.control({ value: null, disabled: true }),
        cobTxNumeroConta: this.fb.control(null),
        cobTxTipoConta: this.fb.control(null),
      }),
    },
    { validators: minimumResponsibleValidator() },
  );

  selectedAgencia = {} as IAgenciaDto;
  agenciaPage?: IPage<IAgenciaDto>;
  agenciaParams = new BehaviorSubject({
    filter: {} as IAgenciaFilter,
    pageable: { page: 0, size: 20 } as IPageable,
  });

  selectedBanco = {} as BancoDto;
  bankList?: IPage<BancoDto>;
  bankListParams = new BehaviorSubject({
    filter: {} as IBancoFilter,
    pageable: { page: 0, size: 20 } as IPageable,
  });

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      return value.trim().length === 0 ? { whitespace: true } : null;
    };
  }

  sanitizeLettersOnly(event: Event, control: AbstractControl): void {
    const input = event.target as HTMLInputElement;
    const sanitized = input.value.replace(/[^\p{L} ]/gu, '');

    if (sanitized !== input.value) {
      input.value = sanitized;
      control.setValue(sanitized);
    }
  }

  currentBankCod?: string;

  tipoContaOptions = enumToDropdownOptions(TipoContaBancariaEnum);

  get contaBancariaForm() {
    return this.userForm.controls.contaBancariaForm;
  }

  private toggleContaValidators(isRequired: boolean) {
    const group = this.contaBancariaForm;

    Object.values(group.controls).forEach((control) => {
      if (isRequired) {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity({ emitEvent: false });
    });

    group.updateValueAndValidity({ emitEvent: false });
  }

  maxDateValidator(maxDate: Date) {
    return (control: AbstractControl) => {
      if (!control.value) return null;
      const inputDate = new Date(control.value);
      if (inputDate > maxDate) {
        return { maxDate: true };
      }
      return null;
    };
  }
  private checked = false;
  private patchingDocuments = false;
  documents = documents;
  attachments = attachments;
  filteredAttachments: AttachmentView[] = [];

  requiredAttachments: AttachmentTypeEnum[] = [];
  requiredDocuments: DocumentTypeEnum[] = [];
  requiredContacts: ContactTypeEnum[] = [];
  requiredDadosBancarios: ContaBancariaEnum[] = [];

  selectedAttachmentsForDelete: AttachmentForm[] = [];

  currentStep = 0;
  multipartFormEnable = false;
  disabledSteps: number[] = [];

  othersValidators = false;
  public maxDisplayedPages = 7;

  positionsOptions?: IPage<IPositionDto>;
  institutionsOptions?: IPage<ITeachingInstitutionDto>;
  federationOptions?: IPage<IFederationBasicDataDto>;
  currentFederationPage = 0;
  federationSearchText = '';
  selectedFederation: IFederationBasicDataDto = {};
  countryOptions?: IPage<ICountryDto>;
  statesOptions?: IPage<IStateDto>;
  cityOptions?: IPage<ICityDto>;
  selectedCountry = {} as ICountryDto;
  selectedState = {} as IStateDto;
  selectedCity = {} as ICityDto;
  public cepValueSetted = false;
  countrySearchText = '';
  stateSearchText = '';
  citySearchText = '';
  countryPage = PageRequest.of(0, 10);
  statePage = PageRequest.of(0, 10);
  cityPage = PageRequest.of(0, 10);
  attachmentTypeOptions?: IPage<IAttachmentTypeDto>;

  institutionFilters$ = new ParamsSubjectBuilder<
    ParamsForList<PageRequest, TeachingInstitutionFilter>
  >({ pagination: { size: 15 } });

  selectedUserInstitution?: ITeachingInstitutionDto;
  isInstitutionVisible: boolean = true;
  isFederationVisible: boolean = true;
  isPositionVisible: boolean = true;

  requiredResponsible: boolean = false;
  /** Borda azul do INEP: papel exige CODIGO_INEP e usuário não é menor de idade. */
  inepShowsRequiredBorder = false;
  @Input() responsibleRegistration: boolean = false;

  @Input() eventForResponsibleValidation?: number;
  selectedEventForResponsibleValidation?: number;
  @Input() responsibleValidation?: IUserFieldsValidatorDto;
  selectedValidationForResponsibleValidation?: IUserFieldsValidatorDto;

  @Output() saveResponsibleEmit = new EventEmitter<IUserDto>();
  @Output() cancelResponsibleEmit = new EventEmitter<void>();
  responsibleRegistrationModalVisible = false;
  responsibleEditId?: number;

  searchResponsibleControl = new FormControl<string>('');
  selectDocumentControl = new FormControl<DocumentTypeEnum | null>(null);

  @Input() addressFg?: FormGroup<ControlsOf<AddressForm>>;
  liveInTheSameHouse = new FormControl<boolean>(false);

  userValidators: IPage<IUserFieldsValidatorDto> = {};
  validatorSearchText = '';
  eventUserValidators?: IEventValidationsDto;
  selectedUserValidator = {} as IUserFieldsValidatorDto;

  // EDIT
  @Input() usuNrId?: number;
  currentUserStoredData?: IUserDto;
  currentAddressStoredData: IAddressDto[] = [];
  currentContactsStoredData: IContactDto[] = [];
  currentDocumentsStoredData: IDocumentDto[] = [];
  currentAttachmentsStoredData: IAttachmentDto[] = [];
  currentResponsiblesStoredData: IUserResponsibleDto[] = [];
  currentContaBancariaStoredData: ContaBancariaDto | null = null;

  @Input() editUserExternalData?: UserExternalEdit;
  @Input({ transform: booleanAttribute }) externalEdit?: boolean;
  @Output() successExternalEdition = new EventEmitter<void>();

  @Input() isModal: boolean = false;
  @Output() cancelModal = new EventEmitter<void>();

  @Output() crefStatusChange = new EventEmitter<boolean>();

  eventControl = new FormControl<number | null>(null);
  selectedEvent: IEventDto | null = null;
  eventParams = new BehaviorSubject({
    filter: {} as EventFilter,
    pageable: { page: 0, size: 10 } as IPageable,
  });
  //conferir esse event control
  userValidationControl = new FormControl<UserType | null>(null);
  eventsOptions?: IPage<IEventDto>;

  allUserTypeOptions = enumToDropdownOptions(UserType);
  filteredUserTypeOptions: any[] = [...this.allUserTypeOptions];
  userValidationPageOptions: any[] = [];
  userValidationCurrentPage = 0;
  userValidationTotalPages = 1;
  userValidationSearchText = '';
  selectedUserValidation: any | null = null;

  searchInstitutionSubject = new Subject<string>();

  previewPhotoForEditingState?: string;

  showBankForm = false;

  cpfControlMessage: string | null = null;
  cpfRedirectData?: ValidadorDocumentosEhContatosDto;
  openModalCpfValidation = false;
  cpfValidationLoading = false;

  loadingPhoneValidation = false;
  phoneControlMessage: string | null = null;
  loadingEmailValidation = false;
  emailControlMessage: string | null = null;
  invalidEmails: string[] = [];
  existingEmails: string[] = [];
  existingPhones: string[] = [];

  readonly regex = regex;
  readonly Utils = Utils;
  readonly SexoEnum = GenreEnum;
  readonly InputTypeEnum = InputTypeEnum;
  readonly ContactTypeEnum = ContactTypeEnum;
  readonly DocumentTypeEnum = DocumentTypeEnum;
  readonly BloodTypeEnum = BloodTypeEnum;
  readonly DominantHandEnum = DominantHandEnum;
  readonly AttachmentTypeEnum = AttachmentTypeEnum;
  readonly UserBasicDataEnum = UserBasicDataEnum;
  readonly DegreeOfRelationshipEnum = DegreeOfRelationshipEnum;
  readonly UserType = UserType;

  #router = inject(Router);
  #userService = inject(UserService);
  #userValidationFieldsService = inject(UserValidatorFieldsService);
  #authService = inject(AuthService);
  #positionService = inject(PositionService);
  #federationService = inject(FederationService);
  #countryService = inject(CountryService);
  #stateService = inject(StateService);
  #cityService = inject(CityService);
  #cepService = inject(ViaCepService);
  #eventService = inject(EventService);
  #institutionService = inject(TeachingInstitutionService);
  #attachmentTypeService = inject(AttachmentTypeService);
  #snackbarService = inject(SnackbarService);
  #loadingService = inject(LoadingService);
  #photoEditorService = inject(NgxPhotoEditorService);
  #attachmentService = inject(AttachmentService);
  #cdr = inject(ChangeDetectorRef);
  #useTermsService = inject(UseTermsService);
  #confirmationModalService = inject(ConfirmationModalService);
  #documentValidationService = inject(DocumentVaildationService);

  protected readonly handlerErrorMessage = inject(HandlerErrorMessage);
  protected readonly userFormApiError = inject(UserFormApiErrorService);

  openModalUseTerms: boolean = false;
  useTerms?: IUseTermDto;
  TermTypeEnum = TermTypeEnum;

  get insNrId() {
    return this.userForm.controls.basicData.controls.insNrId;
  }
  get usuTxCodigoInep(){
    return this.userForm.controls.basicData.controls.usuTxCodigoInep;
  }

  ngOnInit(): void {
    this.updateUserValidationPageOptions();
    this.#useTermsService
      .getUseTerms$(1)
      .subscribe((value) => (this.useTerms = value));
    const dataForm = this.userForm.controls.basicData.controls;
    dataForm.carNrId.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value) => {
        if (value == 2) {
          dataForm.insNrId.setValidators(Validators.required);
        } else {
          dataForm.insNrId.removeValidators(Validators.required);
        }
        dataForm.insNrId.updateValueAndValidity();
      });

    this.#setupChangeFederation();
    this.#setupChangeInstitution();
    this.#setupSearchResponsible();
    this.#setupControlRequiredResponsible();
    this.#setupAddressFormValueChanges();
    this.#setupChangeContaBancariaForm();
    this.#findData();

    this.userForm.controls.contacts.valueChanges
      .pipe(debounceTime(50), takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.#updateRequiredContacts();
      });

    this.#setupRequiredContacts();
    this.#setupRequiredAttachments();
    this.#setupFederationAndInstitutionAccordingToLoggedUser();
    this.#setupChangeEventControl();
    this.#setupChangeUserValidationControl();

    // apenas para edicao de responsaveis
    if (this.eventForResponsibleValidation && this.responsibleValidation) {
      this.eventControl.setValue(this.eventForResponsibleValidation);
    }

    this.#setupChangeFedNrId();
    this.usuTxCodigoInep.markAsTouched();
  }

  ngAfterViewChecked(): void {
    if (!this.checked) {
      this.#setupRequiredDocuments();
    }
    if (this.externalEdit) {
      this.userForm.controls.documents.updateValueAndValidity({
        emitEvent: false,
      });
      this.userForm.controls.attachments.updateValueAndValidity({
        emitEvent: false,
      });
      this.#cdr.detectChanges();
    }
  }

  searchValidator(name: string) {
    this.validatorSearchText = name || '';
    this.#loadValidatorsPage(0);
  }

  loadValidatorsPaged(page: number): void {
    this.#loadValidatorsPage(page);
  }

  getCpfErrorMessage(docTxTipo: DocumentTypeEnum | null): string | null {
    if (docTxTipo !== DocumentTypeEnum.CPF) return null;
    return this.cpfControlMessage;
  }

  getContactErrorMessage(control: ControlsOf<ContactForm>): string | null {
    const conTxTipo = control.conTxTipo.value;
    const conTxContato = control.conTxContato.value;

    if (
      conTxTipo == ContactTypeEnum.Telefone &&
      this.existingPhones.some((con) => con == conTxContato)
    ) {
      return 'Telefone já existe';
    }
    if (conTxTipo == ContactTypeEnum.Email) {
      if (this.existingEmails.some((email) => email == conTxContato)) {
        return 'Email já existe';
      }
      if (this.invalidEmails.some((email) => email == conTxContato)) {
        return 'Email inválido';
      }
    }
    return null;
  }

  fieldErrorMessage(
    fg: FormGroup,
    key: string,
    arrayContext?: string | null,
  ): string {
    return this.userFormApiError.fieldErrorMessage(fg, key, arrayContext);
  }

  #resolveUserFormApiErrors(error: ResponseDto<unknown>): void {
    this.userFormApiError.resolveApiErrors(error, this.userForm);
    this.#cdr.detectChanges();
  }

  private loadBancoList() {
    if (!this.showBankForm) return;
    this.bancoService
      .buscarBancos(
        this.bankListParams.value.filter,
        this.bankListParams.value.pageable,
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res) => {
          this.bankList = res;
        },
        error: (err) => {
          this.#resolveUserFormApiErrors(err);
        },
      });
  }

  getToday(): string {
    const now = new Date();
    return now.toISOString().split('T')[0];
  }

  checkCrefStatus(): void {
    const hasCref = this.userForm.controls.documents.controls.some(
      (fg) =>
        fg.controls.docTxTipo.value === DocumentTypeEnum.CREF &&
        !!fg.controls.docTxDocumento.value,
    );
    this.crefStatusChange.emit(hasCref);
  }

  #findData(): void {
    this.#fetchUserValidators();
    this.#fetchAttachmentTypes();
    this.#fetchEvents();
    this.#findUserData();
    this.#fetchPositions();
    this.#fetchfederations();
    this.#setInstitutionSubscription();
    this.#fetchCountries();
  }

  #findUserData(): void {
    if (this.usuNrId) this.#fetchUserById(this.usuNrId);
  }

  editExternalUser(): void {
    this.usuNrId = this.editUserExternalData?.usuNrId!;
    if (this.editUserExternalData?.eveNrId) {
      this.#eventService
        .findValidationsFromEvent(this.editUserExternalData?.eveNrId)
        .subscribe((res) => {
          this.eventUserValidators = res;

          this.selectedUserValidator = this.#getValidationFromUserType(
            this.editUserExternalData?.externalTypeEdit!,
          ) || {} as IUserFieldsValidatorDto;
          this.#changeUserValidator(this.selectedUserValidator?.uvcNrId!);
        });
    }
  }

  onSubmit(): void {
    const basicData =
      this.userForm.controls.basicData.getRawValue() as UserForm;
    const useTerms =
      this.userForm.controls.termoUsoForm.getRawValue() as UseTermsForm;
    const basicDataForm = { ...basicData, termoUsoForm: useTerms };
    const addressForm: AddressForm =
      this.userForm.controls.address.getRawValue() as AddressForm;
    const contactsForm =
      this.userForm.controls.contacts.getRawValue() as ContactForm[];
    const documentsForm =
      this.userForm.controls.documents.getRawValue() as DocumentForm[];
    const attachmentsForm =
      this.userForm.controls.attachments.getRawValue() as AttachmentForm[];
    const responsiblesForm =
      this.userForm.controls.responsibles.getRawValue() as UserResponsibleForm[];

    const updatedAttachments = [...attachmentsForm];

    const deletedAttachments: AttachmentForm[] = [];

    if (addressForm.logTxCep === '') addressForm.logTxCep = undefined;

    this.currentAttachmentsStoredData.forEach((storedAttachment) => {
      const sameIdExists = attachmentsForm.some(
        (attachment) => attachment.entNrId === storedAttachment.aneNrId,
      );

      const sameTypeExists = attachmentsForm.some((attachment) => {
        return (
          attachment.entNrId == null &&
          attachment.tipNrId === storedAttachment.tipNrId
        );
      });

      if (!sameIdExists && sameTypeExists) {
        const index = updatedAttachments.findIndex(
          (attachment) =>
            !attachment.entNrId &&
            attachment.tipNrId === storedAttachment.tipNrId,
        );

        if (index !== -1) {
          updatedAttachments[index] = {
            ...updatedAttachments[index],
            entNrId: storedAttachment.aneNrId,
            entTxMetadado: MetadataPutEnum.ALTERADO,
          };
        }
      }

      if (!sameIdExists && !sameTypeExists) {
        deletedAttachments.push({
          ...storedAttachment,
          entNrId: storedAttachment.aneNrId,
          entTxMetadado: MetadataPutEnum.DELETADO,
        } as AttachmentForm);
      }
    });

    this.selectedAttachmentsForDelete = deletedAttachments;
    if (this.isEdit) {
      if (deletedAttachments.length === 0) {
        this.#updateProcess(
          basicDataForm,
          addressForm,
          contactsForm,
          documentsForm,
          updatedAttachments,
          responsiblesForm,
        );
      } else {
        this.confirmDeletionAndUpdate(
          basicDataForm,
          addressForm,
          contactsForm,
          documentsForm,
          updatedAttachments,
          responsiblesForm,
        );
      }
    } else {
      this.#registerProcess(
        basicDataForm,
        addressForm,
        contactsForm,
        documentsForm,
        updatedAttachments,
        responsiblesForm,
      );
    }
  }

  confirmDeletionAndUpdate(
    basicDataForm: UserForm,
    addressForm: AddressForm,
    contactsForm: ContactForm[],
    documentsForm: DocumentForm[],
    attachmentsForm: AttachmentForm[],
    responsiblesForm: UserResponsibleForm[],
  ) {
    const attachmentNamesForDelete = this.selectedAttachmentsForDelete
      .map((attForDelete) => {
        const type = this.attachmentTypeOptions?.content?.find(
          (att) => att.tipNrId === attForDelete.tipNrId,
        );
        return type?.tipTxDescricao;
      })
      .join(', ');

    this.#confirmationModalService.openModal({
      modalType: ConfirmationModalType.danger,
      cancelText: 'Cancelar',
      confirmText: 'Excluir',
      message: 'Deseja realmente excluir o anexo',
      resourceName: attachmentNamesForDelete,
      callbackExecuteAction: () => {
        this.#updateProcess(
          basicDataForm,
          addressForm,
          contactsForm,
          documentsForm,
          attachmentsForm,
          responsiblesForm,
        );
      },
    });

    this.selectedAttachmentsForDelete = [];
  }

  #registerProcess(
    basicDataForm: UserForm,
    addressForm: AddressForm,
    contactsForm: ContactForm[],
    documentsForm: DocumentForm[],
    attachmentsForm: AttachmentForm[],
    responsiblesForm: UserResponsibleForm[],
  ): void {
    this.#loadingService.activate();
    basicDataForm.entTxMetadado = MetadataPutEnum.CRIADO;
    addressForm.entTxMetadado = MetadataPutEnum.CRIADO;

    const contactFormFiltered = contactsForm.filter(
      (contact) => contact.conTxContato !== null && contact.conTxContato !== '',
    );
    contactFormFiltered.forEach(
      (contact) => (contact.entTxMetadado = MetadataPutEnum.CRIADO),
    );

    const documentsFormFiltered = documentsForm.filter(
      (doc) => doc.docTxDocumento !== null && doc.docTxDocumento.trim() !== '',
    );
    documentsFormFiltered.forEach(
      (document) => (document.entTxMetadado = MetadataPutEnum.CRIADO),
    );

    attachmentsForm.forEach(
      (attachment) => (attachment.entTxMetadado = MetadataPutEnum.CRIADO),
    );
    responsiblesForm.forEach(
      (responsible) => (responsible.entTxMetadado = MetadataPutEnum.CRIADO),
    );

    if (this.contaBancariaForm.value.cobTxNumeroConta == '') {
      this.contaBancariaForm.controls.cobTxNumeroConta.setValue(null);
    }

    const raw = this.contaBancariaForm.getRawValue();

    const contaBancariaForm =
      this.showBankForm && raw.banNrId
        ? ({
            ...raw,
            entTxMetadado: MetadataPutEnum.CRIADO,
          } as ContaBancariaForm)
        : null;

    const generalForm: UserRelationshipForm = {
      usuarioForm: {
        ...basicDataForm!,
        usuListResponsavel: responsiblesForm ?? [],
      },
      usuListCon: contactFormFiltered.length > 0 ? contactFormFiltered : null,
      usuListDoc:
        documentsFormFiltered.length > 0 ? documentsFormFiltered : null,
      usuListAne: attachmentsForm.length > 0 ? attachmentsForm : null,
      usuListLog: addressForm ? [addressForm] : null,
      contaBancariaForm: this.showBankForm ? contaBancariaForm : null,
    };

    // TODO:
    // - adicionar um exahust map pra salvar um usuario

    this.#userService
      .manageRegisterUserReference$(generalForm)
      .pipe(
        tap((userRegistered) => {
          if (this.responsibleRegistration) {
            this.saveResponsibleEmit.emit(userRegistered.usuario);
          }
        }),
        switchMap((userUpdated) => this.#validateUserRegistration(userUpdated)),
      )
      .subscribe({
        next: (userSaved) => {
          this.#loadingService.deactivate();
          if (this.responsibleRegistration) {
            this.#snackbarService.showInfo(
              'Responsável cadastrado com sucesso! Agora, finalize o cadastro do atleta.',
            );
          } else {
            this.#snackbarService.showSuccess(
              'Dados básicos do usuário cadastrados com sucesso.',
            );

            this.#router.navigate([
              'usuarios',
              'editar',
              userSaved.usuario.usuNrId,
            ]);
          }
        },
        error: (error) => {
          this.#loadingService.deactivate();
          this.#resolveUserFormApiErrors(error);
        },
      });
  }

  #updateProcess(
    basicDataForm?: UserForm,
    addressForm?: AddressForm,
    contactsForm?: ContactForm[],
    documentsForm?: DocumentForm[],
    attachmentsForm?: AttachmentForm[],
    responsiblesForm?: UserResponsibleForm[],
  ): void {
    this.#loadingService.activate();

    const userForSend = basicDataForm
      ? this.#updateBasicData(basicDataForm!, responsiblesForm!)
      : null;

    const contactsForSend = this.#updateContacts(contactsForm!);
    const documentsForSend = this.#updateDocuments(documentsForm!);
    const attachmentForSend = this.#updateAttachments(attachmentsForm!);

    let addressForSend: AddressForm | null = null;
    if (addressForm?.entNrId === null) {
      addressForSend = addressForm;
      addressForm.entTxMetadado = MetadataPutEnum.CRIADO;
    } else {
      addressForSend = this.#updateAddress(addressForm!);
    }

    const raw = this.contaBancariaForm.getRawValue() as ContaBancariaForm;

    const contaBancariaForm = this.showBankForm && raw.banNrId ? raw : null;

    const contaBancariaDto = this.currentContaBancariaStoredData;

    if (contaBancariaForm) {
      verifyContaBancariaChanges(contaBancariaForm, contaBancariaDto);
    }

    const contaBancariaValue = this.showBankForm ? contaBancariaForm : null;

    const generalForm: UserRelationshipForm = {
      usuarioForm: userForSend,
      usuListCon: contactsForSend,
      usuListDoc: documentsForSend,
      usuListAne: attachmentForSend,
      usuListLog: addressForSend ? [addressForSend] : null,
      contaBancariaForm: contaBancariaValue,
    };

    this.#userService
      .manageUpdateUserReference$(generalForm, this.usuNrId!)
      .pipe(
        switchMap((userUpdated) => this.#validateUserRegistration(userUpdated)),
      )
      .subscribe({
        next: (userSaved) => {
          this.successExternalEdition.emit();
          this.#snackbarService.showSuccess('Usuário atualizado com sucesso.');
          this.#loadingService.deactivate();
          this.#fillFormWithResponse(userSaved);
        },
        error: (error) => {
          this.#loadingService.deactivate();
          this.#resolveUserFormApiErrors(error);
        },
      });
  }

  #fetchUserById(usuNrId: number) {
    this.#userService
      .fetchCompleteUserReference$(usuNrId)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((userFetched) =>
          this.#fetchInstitutionById(userFetched.usuario.insNrId!),
        ),
      )
      .subscribe({
        next: (userFetched) => {
          this.#fillFormWithResponse(userFetched);
          this.#loadStatesAndCitiesWithoutEventForm();
        },
        error: (error) => this.#resolveUserFormApiErrors(error),
      });
  }

  #loadStatesAndCitiesWithoutEventForm() {
    const paiNrId = this.userForm.controls.address.controls.paiNrId.value;
    if (paiNrId) {
      this.#countryService
        .getAllStatesByCountryId(paiNrId)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((states) => {
          this.statesOptions = states;
          this.selectedState = states.content?.find(
            (state) =>
              state.estNrId === this.userForm.controls.address.controls.estNrId.value,
          ) || {} as IStateDto;

          const estNrId = this.userForm.controls.address.controls.estNrId.value;
          if (estNrId) {
            this.#stateService
              .getAllCitiesByStateId(estNrId)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((cities) => {
                this.cityOptions = cities;
                this.selectedCity = cities.content?.find(
                  (city) =>
                    city.cidNrId === this.userForm.controls.address.controls.cidNrId.value,
                ) || {} as ICityDto;
              });
          }
        });
    }
  }

  #validateUserRegistration(
    userSaved: IUserRelationshipDto,
  ): Observable<IUserRelationshipDto> {
    if (!this.selectedUserValidator.uvcNrId) return of(userSaved);
    return this.#userValidationFieldsService
      .validateUserRegistration$(
        this.selectedUserValidator.uvcNrId,
        userSaved.usuario.usuNrId!,
      )
      .pipe(
        tap((resValidation) => {
          if (resValidation.uvcListCampos?.length! > 0) {
            this.handlerErrorMessage.handleUserValidationFields(
              resValidation,
              this.userForm.controls.basicData,
              UserStepValidationEnum.USUARIO,
            );
            throw new Error(
              'Existem dados básicos obrigatórios não preenchidos',
            );
          }

          if (resValidation.uvcListLogradouro?.length! > 0) {
            this.handlerErrorMessage.handleUserValidationFields(
              resValidation,
              this.userForm.controls.address,
              UserStepValidationEnum.LOGRADOURO,
            );
            throw new Error(
              'Existem campos do endereço obrigatórios não preenchidos',
            );
          }

          if (resValidation.uvcListContatos?.length! > 0) {
            // TODO: Implementar lógica para campos de contato
            // this.handlerErrorMessage.handleUserValidationFields(resValidation, this.userForm.controls.contacts, UserStepValidationEnum.CONTATO);
            throw new Error('Existem contatos obrigatórios não preenchidos');
          }

          if (resValidation.uvcListDocumentos?.length! > 0) {
            this.handlerErrorMessage.handleUserValidationFields(
              resValidation,
              this.userForm.controls.documents,
              UserStepValidationEnum.DOCUMENTO,
            );
            throw new Error('Existem documentos obrigatórios não preenchidos');
          }

          if (resValidation.uvcListAnexos?.length! > 0) {
            this.handlerErrorMessage.handleUserValidationFields(
              resValidation,
              this.userForm.controls.attachments,
              UserStepValidationEnum.ANEXO,
            );
            throw new Error('Existem anexos obrigatórios não preenchidos');
          }
        }),
        catchError((error) => {
          this.#resolveUserFormApiErrors(error);
          return throwError(() => error);
        }),
        map(() => userSaved),
      );
  }

  #fillFormWithResponse(userSaved: IUserRelationshipDto): void {
    const basicData = userSaved.usuario;
    this.currentUserStoredData = basicData;
    this.#mapBasicData(basicData);

    const responsibles = userSaved.responsaveis ?? [];
    this.currentResponsiblesStoredData = responsibles;
    this.#mapResponsiblesData(responsibles);

    const address = userSaved.logradouro ? [userSaved.logradouro] : [];
    this.currentAddressStoredData = address;
    this.#mapAddressData(address);

    const contacts = userSaved.contatos ?? [];
    this.currentContactsStoredData = contacts;
    this.#mapContactsData(contacts);

    const documents = userSaved.documentos ?? [];
    this.currentDocumentsStoredData = documents;
    this.#mapDocumentsData(documents);

    const attachments = userSaved.anexos ?? [];
    this.currentAttachmentsStoredData = attachments;
    this.#mapAttachmentsData(attachments);

    const contaBancaria = userSaved.contaBancaria;
    this.currentContaBancariaStoredData =
      contaBancaria || ({} as ContaBancariaDto);
    this.#mapContaBancaria(contaBancaria);

    this.checkCrefStatus();
  }

  #mapContaBancaria(contaBancaria?: ContaBancariaDto) {
    if (!contaBancaria) return;
    this.showBankForm = true;
    this.loadBancoList();
    this.userForm.controls.basicData.patchValue({ tipoFuncao: 'COLABORADOR' });
    this.contaBancariaForm.controls.ageNrId.enable();
    this.userForm.controls.contaBancariaForm.patchValue({
      banNrId: contaBancaria.banNrId,
      ageNrId: contaBancaria.ageNrId,
      cobTxNumeroConta: contaBancaria?.cobTxNumeroConta ?? null,
      cobTxTipoConta: contaBancaria?.cobTxTipoConta ?? null,
    });

    this.bancoService
      .buscarBancoPorId(contaBancaria.banNrId)
      .subscribe((banco) => {
        this.selectedBanco = banco;
        this.currentBankCod = banco?.banTxCodigo;
      });
    this.agenciaService
      .buscarAgenciaPorId(contaBancaria.ageNrId)
      .subscribe((agencia) => {
        this.selectedAgencia = agencia;
      });
  }

  #updateBasicData(
    basicDataForm: UserForm,
    responsiblesForm: UserResponsibleForm[],
  ): UserForm | null {
    verifyBasicDataChanges(basicDataForm, this.currentUserStoredData!);

    const addedResponsibles = responsiblesForm
      .filter((responsible) => !responsible.entNrId)
      .map((responsible) => ({
        ...responsible,
        entTxMetadado: MetadataPutEnum.CRIADO,
      }));

    const otherResponsibles = responsiblesForm.filter(
      (responsible) => responsible.entTxMetadado !== MetadataPutEnum.CRIADO,
    );

    verifyResponsibleChanges(
      otherResponsibles,
      this.currentResponsiblesStoredData!,
    );

    const deletedResponsibles = this.currentResponsiblesStoredData
      .filter(
        (storedResponsible) =>
          !responsiblesForm.some(
            (responsible) => responsible.entNrId === storedResponsible.ureNrId,
          ),
      )
      .map((responsible) => {
        return {
          entNrId: responsible.ureNrId,
          respNrId: responsible.usuNrId,
          ureTxParentesco: responsible.ureTxParentesco,
          entTxMetadado: MetadataPutEnum.DELETADO,
        } as UserResponsibleForm;
      });

    const form: UserForm = {
      ...basicDataForm,
      usuListResponsavel: [
        ...addedResponsibles,
        ...deletedResponsibles,
        ...otherResponsibles,
      ],
    };

    return form;
  }

  #updateAddress(addressForm: AddressForm): AddressForm | null {
    verifyAddressChanges(addressForm, this.currentAddressStoredData!);

    // resolucao temporária pra bug (o - quebrava o limite de 8 caracteres do cep)
    addressForm = {
      ...addressForm,
      logTxCep: addressForm.logTxCep?.replace('-', ''),
    };

    return addressForm;
  }

  #updateContacts(contactsForm: ContactForm[]): ContactForm[] | null {
    const addedContacts = contactsForm
      .filter((contact) => !contact.entNrId && contact.conTxContato)
      .map((contact) => ({
        ...contact,
        entTxMetadado: MetadataPutEnum.CRIADO,
      }));

    const deletedContacts = this.currentContactsStoredData
      .filter(
        (storedContact) =>
          !contactsForm.some(
            (contact) => contact.entNrId === storedContact.conNrId,
          ),
      )
      .map((contact) => {
        return {
          ...contact,
          entNrId: contact.conNrId,
          entTxMetadado: MetadataPutEnum.DELETADO,
        } as ContactForm;
      });

    this.cleanTrashFormContacts(deletedContacts);

    const otherContacts = contactsForm.filter(
      (contact) =>
        contact.entTxMetadado !== MetadataPutEnum.CRIADO &&
        contact.entTxMetadado !== MetadataPutEnum.DELETADO,
    );

    verifyContactsChanges(otherContacts, this.currentContactsStoredData!);

    const entObjForms = [
      ...addedContacts,
      ...deletedContacts,
      ...otherContacts,
    ];

    return entObjForms;
  }

  #updateDocuments(documentsForm: DocumentForm[]): DocumentForm[] | null {
    console.log('documentsForm', documentsForm);

    const documentsFormFiltered = documentsForm.filter(
      (doc) =>
        (doc.docTxDocumento !== null && doc.docTxDocumento.trim() !== '') ||
        doc.entTxMetadado == MetadataPutEnum.DELETADO,
    );

    console.log('documentsFormFiltered', documentsFormFiltered);

    const addedDocuments = documentsFormFiltered
      .filter((document) => !document.entNrId && document.docTxDocumento)
      .map((document) => ({
        ...document,
        entTxMetadado: MetadataPutEnum.CRIADO,
      }));

    const deletedDocuments = documentsFormFiltered
      .filter((doc) => doc.entTxMetadado == MetadataPutEnum.DELETADO)
      .map((doc) => {
        const docTxValue = this.currentDocumentsStoredData.find(
          (storedDoc) => doc.entNrId == storedDoc.docNrId,
        );
        return {
          ...doc,
          docTxDocumento: docTxValue?.docTxDocumento,
          docTxOrgaoExpeditor: docTxValue?.docTxOrgaoExpeditor,
        } as DocumentForm
      });

    // .filter((storedDocument) => {
    //   const hasDocumentInField = storedDocument.docTxDocumento?.length === 0;
    //   const notNewDocument =
    //     storedDocument.docTxDocumento !== MetadataPutEnum.CRIADO;
    //   return notNewDocument && hasDocumentInField;
    // })
    // .map((document) => {
    //   const storedDocument = this.currentDocumentsStoredData?.find(
    //     (doc) => doc.docNrId === document.entNrId,
    //   );
    //   return {
    //     ...document,
    //     entNrId: document.entNrId,
    //     entTxMetadado: MetadataPutEnum.DELETADO,
    //     docTxDocumento: storedDocument?.docTxDocumento,
    //   } as DocumentForm;
    // });
    this.cleanTrashFormDocuments(deletedDocuments);
    const otherDocuments = documentsFormFiltered.filter(
      (document) =>
        document.entTxMetadado === MetadataPutEnum.INALTERADO &&
        document.docTxDocumento,
    );

    verifyDocumentsChanges(otherDocuments, this.currentDocumentsStoredData!);

    const entObjForms = [
      ...addedDocuments,
      ...deletedDocuments,
      ...otherDocuments,
    ];

    return entObjForms;
  }

  #updateAttachments(
    attachmentsForm: AttachmentForm[],
  ): AttachmentForm[] | null {
    // se os tipos de anexos não forem carregados, não é possível atualizar os anexos
    if (this.attachmentTypeOptions?.content?.length === 0) {
      this.#snackbarService.showWarn(
        'Não foi possível carregar os anexos do usuário, pois os tipos de anexos não foram carregados',
      );
      return [];
    }

    const addedAttachments = attachmentsForm
      .filter((attachment) => !attachment.entNrId && attachment.aneBtAnexo)
      .map((attachment) => ({
        ...attachment,
        entTxMetadado: MetadataPutEnum.CRIADO,
      }));

    const deletedAttachments = this.currentAttachmentsStoredData
      .filter(
        (storedAttachment) =>
          !attachmentsForm.some(
            (attachment) => attachment.entNrId === storedAttachment.aneNrId,
          ),
      )
      .map((attatchment) => {
        return {
          ...attatchment,
          entNrId: attatchment.aneNrId,
          entTxMetadado: MetadataPutEnum.DELETADO,
        } as AttachmentForm;
      });

    const updatedAttachments = attachmentsForm.filter(
      (attachment) => attachment.entTxMetadado === MetadataPutEnum.ALTERADO,
    );
    const otherAttachments = attachmentsForm.filter(
      (attachment) =>
        attachment.entTxMetadado === MetadataPutEnum.INALTERADO &&
        attachment.aneBtAnexo &&
        attachment.aneNrId !== null &&
        attachment.aneNrId !== undefined,
    );

    // verifyAttachmentsChanges
    otherAttachments.forEach((attachment) => {
      const storedAttachment = this.currentAttachmentsStoredData?.find(
        (att) => att.aneNrId === attachment.entNrId,
      );
      if (storedAttachment) {
        const hasChanges =
          storedAttachment.aneBtAnexo !== attachment.aneBtAnexo;
        if (hasChanges) {
          attachment.entTxMetadado = MetadataPutEnum.ALTERADO;
        }
      }
    });

    const entObjForms = [
      ...addedAttachments,
      ...deletedAttachments,
      ...otherAttachments,
      ...updatedAttachments,
    ];

    return entObjForms;
  }

  #fetchInstitutionById(insNrId: number) {
    if (!insNrId) return;

    this.#institutionService
      .getInstitutionById$(insNrId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((institution) => {
        this.selectedUserInstitution = institution;
      });
  }

  #mapBasicData(basicData: IUserDto): void {
    this.userForm.controls.basicData.patchValue({
      entNrId: basicData.usuNrId,
      usuTxNome: basicData.usuTxNome,
      usuTxCodigoInep: basicData.usuTxCodigoInep,
      fedNrId: basicData.fedNrId,
      insNrId: basicData.insNrId,
      carNrId: basicData.carNrId,
      usuBlAuxilioBrasil: basicData.usuBlAuxilioBrasil,
      usuDtNascimento: basicData.usuDtNascimento,
      usuNrAltura:
        basicData.usuNrAltura != null
          ? Number(basicData.usuNrAltura).toFixed(2)
          : null,
      usuNrPeso:
        basicData.usuNrPeso != null
          ? Number(basicData.usuNrPeso).toFixed(2)
          : null,
      usuTxSexo: basicData.usuTxSexo,
      usuTxTipoSanguineo: basicData.usuTxTipoSanguineo,
      usuTxLadoDominante: basicData.usuTxLadoDominante,
      entTxMetadado: MetadataPutEnum.INALTERADO,
    });
    this.userForm.controls.termoUsoForm.patchValue({
      terNrId: basicData.terNrId,
      usuBlTermoDeUso: basicData.terNrId ? true : false,
    });
    const findFederation = this.federationOptions?.content?.find(fed => fed.fedNrId === basicData.fedNrId);
    if(!findFederation) {
      this.#getFederationById(basicData.fedNrId!)
    }else{
      this.selectedFederation = findFederation;
    }
  }

  #mapResponsiblesData(responsibles: IUserResponsibleDto[]): void {
    this.userForm.controls.responsibles.clear();
    responsibles.forEach((responsible) => {
      const responsibleForm = this.fb.group<UserResponsibleViewFg>({
        usuTxNome: this.fb.control(responsible.usuTxNome!),
        entNrId: this.fb.control(responsible.ureNrId),
        respNrId: this.fb.control(responsible.usuNrId, Validators.required),
        ureTxParentesco: this.fb.control(responsible.ureTxParentesco),
        entTxMetadado: this.fb.control(MetadataPutEnum.INALTERADO),
      });
      this.userForm.controls.responsibles.push(responsibleForm);
    });
  }

  #mapAddressData(address: IAddressDto[]): void {
    const mainAddress = address[0];

    if (mainAddress?.cidNrId && mainAddress?.estNrId) {
      this.userForm.controls.address.controls.cidNrId.enable({
        emitEvent: false,
      });
      this.userForm.controls.address.controls.estNrId.enable({
        emitEvent: false,
      });
    }

    // seta cep sem emitir evento de busca em cenário de edição
    this.userForm.controls.address.controls.logTxCep!.setValue(
      mainAddress?.logTxCep ?? null,
      { emitEvent: false },
    );

    this.userForm.controls.address.patchValue(
      {
        entNrId: mainAddress?.logNrId ?? null,
        logTxBairro: mainAddress?.logTxBairro ?? null,
        logTxLogradouro: mainAddress?.logTxLogradouro ?? null,
        logTxComplemento: mainAddress?.logTxComplemento ?? null,
        logNrNumero: mainAddress?.logNrNumero ?? null,
        cidNrId: mainAddress?.cidNrId ?? null,
        estNrId: mainAddress?.estNrId ?? null,
        paiNrId: mainAddress?.paiNrId ?? null,
        entTxMetadado: MetadataPutEnum.INALTERADO,
      },
      { emitEvent: false },
    );

    const paiNrId = this.countryOptions?.content?.find((country) => country.paiNrId === mainAddress?.paiNrId)?.paiNrId;
    if(!paiNrId && mainAddress?.paiNrId) {
      this.#getCountryById(mainAddress?.paiNrId);
    };
  }

  #mapContactsData(contacts: IContactDto[]): void {
    this.userForm.controls.contacts = this.fb.array<
      FormGroup<ControlsOf<ContactForm>>
    >([]);

    if (contacts?.length) {
      const principal = contacts.find((con) => con.conBlPrincipal);
      if (principal) {
        const principalContactForm = this.fb.group<ControlsOf<ContactForm>>({
          entNrId: this.fb.control(principal.conNrId!),
          conTxContato: this.fb.control<string | null>(principal.conTxContato!),
          conTxTipo: this.fb.control(principal.conTxTipo!),
          conBlPrincipal: this.fb.control(principal.conBlPrincipal!),
          entTxMetadado: this.fb.control(MetadataPutEnum.INALTERADO),
        });
        this.userForm.controls.contacts.push(principalContactForm);
        this.#subscibeContactValueChanges(principalContactForm);
      }

      contacts.forEach((contact) => {
        const contactForm = this.fb.group<ControlsOf<ContactForm>>({
          entNrId: this.fb.control(contact.conNrId!),
          conTxContato: this.fb.control<string | null>(contact.conTxContato!),
          conTxTipo: this.fb.control(contact.conTxTipo!),
          conBlPrincipal: this.fb.control(contact.conBlPrincipal!),
          entTxMetadado: this.fb.control(MetadataPutEnum.INALTERADO),
        });
        if (!contact.conBlPrincipal) {
          this.userForm.controls.contacts.push(contactForm);
          this.#subscibeContactValueChanges(contactForm);
        }
      });
    }

    this.#setupRequiredContacts();
    this.#updateRequiredContacts();
  }

  #mapAttachmentsData(attachments: IAttachmentDto[]): void {
    const attachmentsTypesIds = attachments.map((att) => att.tipNrId);
    const attachmentsTypes = this.attachmentTypeOptions?.content
      ?.filter((att) => attachmentsTypesIds.includes(att.tipNrId!))
      .map((att) => att.tipTxDescricao!);

    const tipNrIdPhoto = this.attachmentTypeOptions?.content?.find(
      (att) => att.tipTxDescricao === AttachmentTypeEnum.FOTO,
    )?.tipNrId;

    const runAfterSetup = () => {
      this.userForm.controls.attachments.controls.forEach((fg) => {
        const attachmentData = attachments.find(
          (att) => att.tipNrId === fg.controls.tipNrId.value,
        );

        if (attachmentData?.tipNrId === tipNrIdPhoto) {
          this.#getBase64FromId(attachmentData!.aneNrId!);
        }

        fg.patchValue({
          entNrId: attachmentData?.aneNrId,
          aneNrId: attachmentData?.aneNrId,
          aneBtAnexo: attachmentData?.aneBtAnexo,
          aneTxExtensaoAnexo: attachmentData?.aneTxExtensaoAnexo,
          entTxMetadado: MetadataPutEnum.INALTERADO,
        });
      });
    };

    this.#setupRequiredAttachments(attachmentsTypes, runAfterSetup);
  }

  #getBase64FromId(aneNrId: number): void {
    this.#attachmentService.findAttachmentById$(aneNrId).subscribe({
      next: (result) => {
        this.previewPhotoForEditingState = result;
      },
      error: (error) => {
        this.#resolveUserFormApiErrors(error);
      },
    });
  }

  #mapDocumentsData(documents: IDocumentDto[]): void {
    this.patchingDocuments = true;
    documents.forEach((document) => {
      const documentFg = this.userForm.controls.documents.controls.find(
        (fg) => fg.controls.docTxTipo.value === document.docTxTipo,
      );

      documentFg?.patchValue({
        entNrId: document?.docNrId,
        docTxDocumento: document?.docTxDocumento,
        docTxOrgaoExpeditor: document?.docTxOrgaoExpeditor,
        entTxMetadado: MetadataPutEnum.INALTERADO,
      });
    });
    this.patchingDocuments = false;
  }

  /**
   * este metodo vai buscar os dados de um step especifico
   * @param step
   */
  #findDataByStep(step: UserFormStep) {
    // a tela de usuários depende desse método, se remover nada mais funcionará
  }

  /**
   * este metodo vai buscar os validadores responsaveis por guiar e validar
   * os dados do tipo de usuário especifico que está sendo cadastrado.
   */
  #fetchUserValidators() {
    this.#loadValidatorsPage(0);
  }

  #loadValidatorsPage(page: number): void {
    const filter: IUserFieldsValidatorFilter = {};
    if (this.validatorSearchText) {
      filter.uvcTxNome = this.validatorSearchText;
    }
    this.#userValidationFieldsService
      .fetchAllValidators$(
        PageRequest.of(page, 10),
        filter,
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res) => {
          this.userValidators = res;
        },
        error: (error) => this.#resolveUserFormApiErrors(error),
      });
  }

  #fetchAttachmentTypes() {
    this.#attachmentTypeService
      .fetchAttachmentTypes$(PageRequest.of(0, 100), AttachmentSphere.USUARIO)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res) => {
          this.attachmentTypeOptions = res;
          this.#setupAttachmentTypesIds();
        },
        error: (error) => this.#resolveUserFormApiErrors(error),
      });
  }

  #setupFederationAndInstitutionAccordingToLoggedUser(): void {
    const tokenData = this.#authService.getCurrentValueOfTokenData();

    if (!this.#authService.isAdminUserAuthenticated()) {
      this.userForm.controls.basicData.controls.fedNrId.setValue(
        tokenData?.fedNrId ?? null,
      );
      this.userForm.controls.basicData.controls.fedNrId.disable();
    }

    if (this.#authService.isInstitutionAuthenticated()) {
      this.userForm.controls.basicData.controls.insNrId.setValue(
        tokenData?.insNrId ?? null,
      );

      this.isFederationVisible = true;
      this.isPositionVisible = false;

      this.#institutionService
        .getInstitutionById$(tokenData?.insNrId!)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((institution) => {
          this.isInstitutionVisible = false;

          this.selectedUserInstitution = institution;
          this.institutionsOptions = { content: [institution] };
        });
    }
  }

  #fetchPositions(): void {
    this.#positionService
      .findAll()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((positions) => (this.positionsOptions = positions));
  }

  #fetchfederations(): void {
    if (!this.#authService.isInstitutionAuthenticated()) {
      this.#loadFederationsPage(0);
      return;
    }
    const tokenData = this.#authService.getCurrentValueOfTokenData();

    this.#federationService
      .getFederationById(tokenData?.fedNrId!)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((federation) => {
        this.federationOptions = { content: [federation], totalPages: 1, number: 0 };
        this.currentFederationPage = 0;
        this.selectedFederation = federation;
      });
  }

  #loadFederationsPage(page: number): void {
    this.currentFederationPage = page;
    this.#federationService
      .getDirectorUserFederation(page, 10, this.federationSearchText)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((federations) => {
          this.federationOptions = federations as IPage<IFederationBasicDataDto>;
          this.#syncSelectedFederation();
        });
  }

  #fetchCountries(): void {
    this.#countryService
      .getAllCountries(
        this.countryPage.page,
        this.countryPage.size,
        this.countrySearchText,
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((countries) => {
        this.countryOptions = countries;
        const paiNrId = this.userForm.controls.address.controls.paiNrId.value;
        if (!paiNrId) return;
        const findedCountry = countries.content?.find(
          (country) =>
            country.paiNrId === paiNrId
        )
        findedCountry ? (this.selectedCountry = findedCountry) : this.#getCountryById(paiNrId);
      });
  }
  #getCountryById(paiNrId: number): void {
    this.#countryService
      .findCountryById(paiNrId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((country) => {
        this.selectedCountry = country;
      });
  }
  #getFederationById(fedNrId: number): void {
    this.#federationService
      .getFederationById(fedNrId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((federation) => {
        this.selectedFederation = federation;
      });
  }

  #setupAddressFormValueChanges(): void {
    const addressControls = this.userForm.controls.address.controls;
    const logTxCep = addressControls.logTxCep!;
    const paiNrId = addressControls.paiNrId!;
    const estNrId = addressControls.estNrId!;
    const cidNrId = addressControls.cidNrId!;
    const logTxLogradouro = addressControls.logTxLogradouro!;
    const logTxBairro = addressControls.logTxBairro!;
    const logNrNumero = addressControls.logNrNumero!;
    const logTxComplemento = addressControls.logTxComplemento!;

    paiNrId.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        tap((pai) => {
          if (!pai) {
            estNrId.disable({ emitEvent: false });
            cidNrId.disable({ emitEvent: false });
            this.selectedState = {} as IStateDto;
            this.selectedCity = {} as ICityDto;
          }
        }),
        filter(Boolean),
        switchMap((pai) =>
          this.#countryService.getAllStatesByCountryId(pai!, 0, 20)
        )
      )
      .subscribe((states) => {
        this.statesOptions = states;
        if (!this.cepValueSetted) {
          estNrId.enable({ emitEvent: false });
          this.selectedState = {} as IStateDto;
          this.selectedCity = {} as ICityDto;
        }
      });

    estNrId.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        tap((est) => {
          if (!est) {
            cidNrId.disable({ emitEvent: false });
            this.selectedCity = {} as ICityDto;
          }
        }),
        filter(Boolean),
        switchMap((est) => this.#stateService.getAllCitiesByStateId(est!))
      )
      .subscribe((cities) => {
        this.cityOptions = cities;
        if (!this.cepValueSetted) {
          cidNrId.enable({ emitEvent: false });
          this.selectedCity = {} as ICityDto;
        }
      });

    cidNrId.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        filter(Boolean)
      )
      .subscribe(() => {
        logTxLogradouro.enable({ emitEvent: false });
        logTxBairro.enable({ emitEvent: false });
        logNrNumero.enable({ emitEvent: false });
        logTxComplemento.enable({ emitEvent: false });
      });

    logTxCep.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        debounceTime(300),
        distinctUntilChanged(),
        tap((cep) => {
          if (cep?.length !== 8) {
            this.cepValueSetted = false;

            paiNrId.enable({ emitEvent: false });

            if (paiNrId.valid) {
              estNrId.enable({ emitEvent: false });
            }

            if (estNrId.valid) {
              cidNrId.enable({ emitEvent: false });
            }
          }
        }),
        filter((cep) => cep?.length === 8),
        switchMap((cep) => this.#cepService.getLogradouroByCep(cep!))
      )
      .subscribe((cep) => {
        this.cepValueSetted = true;

        const pai = cep.viaObjEst?.estObjPais.paiNrId!;
        const est = cep.viaObjEst?.estNrId!;
        const cid = cep.viaObjCid?.cidNrId!;

        if (cep.viaObjEst) {
          this.selectedCountry = cep.viaObjEst.estObjPais;
          paiNrId.patchValue(pai, { emitEvent: true });
          paiNrId.enable({ emitEvent: false });

          this.selectedState = cep.viaObjEst;
          estNrId.patchValue(est, { emitEvent: true });
          estNrId.enable({ emitEvent: false });
        }

        if (cep.viaObjCid) {
          this.selectedCity = cep.viaObjCid;
          cidNrId.patchValue(cid, { emitEvent: true });
          cidNrId.enable({ emitEvent: false });
        }

        if (!this.liveInTheSameHouse.value) {
          if (cep.viaTxLogradouro)
            logTxLogradouro.patchValue(cep.viaTxLogradouro, { emitEvent: false });

          if (cep.viaTxcomplemento)
            logTxComplemento.patchValue(cep.viaTxcomplemento, { emitEvent: false });

          if (cep.viaTxBairro)
            logTxBairro.patchValue(cep.viaTxBairro, { emitEvent: false });
        }
      });
  }

  searchLogradouroByCep(logTxCep: HTMLInputElement) {
    let cepArray = logTxCep.value.split('');
    cepArray.splice(5, 1);
    const cep = cepArray.join('');
    if (cep.length === 8) {
      this.userForm.controls.address.controls.logTxCep!.patchValue(cep, { emitEvent: true });
    }
  }

  #loadStates(paiNrId: number): Observable<IPage<IStateDto>> {
    return this.#stateService.getAllStatesByFilter(this.statePage, {
      paiNrId,
      estTxDescricao: this.stateSearchText,
    });
  }

  #loadCities(estNrId: number): Observable<IPage<ICityDto>> {
    return this.#cityService.getCitiesByFilter(this.cityPage, {
      estNrId,
      cidTxDescricao: this.citySearchText,
    });
  }

  searchCountries(text: string): void {
    this.countrySearchText = text;
    this.countryPage = PageRequest.of(0, 10);
    this.#fetchCountries();
  }

  loadCountriesPaged(page: number): void {
    this.countryPage = PageRequest.of(page, 10);
    this.#fetchCountries();
  }

  searchStates(text: string): void {
    this.stateSearchText = text;
    this.statePage = PageRequest.of(0, 10);
    const paiNrId = this.userForm.controls.address.controls.paiNrId.value;
    if (paiNrId) this.#loadStates(paiNrId).subscribe((states) => (this.statesOptions = states));
  }

  loadStatesPaged(page: number): void {
    this.statePage = PageRequest.of(page, 10);
    const paiNrId = this.userForm.controls.address.controls.paiNrId.value;
    if (paiNrId) this.#loadStates(paiNrId).subscribe((states) => (this.statesOptions = states));
  }

  searchCities(text: string): void {
    this.citySearchText = text;
    this.cityPage = PageRequest.of(0, 10);
    const estNrId = this.userForm.controls.address.controls.estNrId.value;
    if (estNrId) this.#loadCities(estNrId).subscribe((cities) => (this.cityOptions = cities));
  }

  loadCitiesPaged(page: number): void {
    this.cityPage = PageRequest.of(page, 10);
    const estNrId = this.userForm.controls.address.controls.estNrId.value;
    if (estNrId) this.#loadCities(estNrId).subscribe((cities) => (this.cityOptions = cities));
  }

  #setupSearchResponsible(): void {
    const today = new Date();
    const date18YearsAgo = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate(),
    );
    const dateString18YearsAgo = date18YearsAgo.toISOString().split('T')[0];

    this.searchResponsibleControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        notNull(),
        filter((searchText) => searchText?.length >= 11),
        switchMap((searchText) =>
          this.#userService.fetchResponsibles$(
            {
              usuTxDocumento: searchText,
              docTxTipo: this.selectDocumentControl.value!,
            },
            PageRequest.default(),
          ),
        ),
      )
      .subscribe({
        next: (user) => {
          this.responsibleAdd(user.content![0]);
        },
        error: (error) => this.#resolveUserFormApiErrors(error),
      });
  }

  #setInstitutionSubscription(): void {
    this.institutionFilters$
      .asObservable()
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(({ filters, pagination }) => {
          if (this.#authService.isInstitutionAuthenticated()) return false;

          const temFiltroMinimo =
            (filters?.insTxNome?.length ?? 0) >= 3 ||
            (filters?.insTxCnpj?.length ?? 0) >= 3 ||
            (filters?.insTxCodigoInep?.length ?? 0) >= 3;

          const mudouPagina = pagination?.page != null;

          return temFiltroMinimo || mudouPagina;
        }),
        debounceTime(500),
        switchMap(({ pagination, filters }) =>
          this.#institutionService.getAllTeachingInstitution(
            filters,
            pagination,
          ),
        ),
      )
      .subscribe({
        next: (institutions) => {
          this.institutionsOptions = institutions;
        },
        error: (error) => this.#resolveUserFormApiErrors(error),
      });
  }

  redirectToFirstStepWithError(): void {
    if (this.userForm.controls.basicData.invalid) {
      this.currentStep = 0;
    } else if (this.userForm.controls.address.invalid) {
      this.currentStep = 1;
    } else if (this.userForm.controls.contacts.invalid) {
      this.currentStep = 2;
    } else if (this.userForm.controls.documents.invalid) {
      this.currentStep = 3;
    } else if (this.userForm.controls.attachments.invalid) {
      this.currentStep = 4;
    }
  }

  responsibleAdd(responsibleSaved: IUserDto): void {
    if (this.userForm.controls.responsibles.controls.length >= 3) {
      this.#snackbarService.showInfo('Limite de responsáveis atingido');
      return;
    }

    if (
      this.userForm.controls.responsibles.controls.some(
        (fg) => fg.controls?.respNrId?.value === responsibleSaved.usuNrId,
      )
    ) {
      this.#snackbarService.showInfo('Responsável já adicionado');
      return;
    }

    console.log('responsible saved', responsibleSaved);

    const responsibleForm = this.fb.group<UserResponsibleViewFg>({
      respNrId: this.fb.control(responsibleSaved.usuNrId!),
      usuTxNome: this.fb.control(responsibleSaved.usuTxNome!),
      ureTxParentesco: this.fb.control(null, Validators.required),
      entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
    });
    this.userForm.controls.responsibles.push(responsibleForm);

    this.responsibleRegistrationModalVisible = false;
  }

  editResponsibleSelected(index: number): void {
    const responsibleFg = this.userForm.controls.responsibles.at(index);
    const usuNrId = responsibleFg.controls.respNrId?.value!;
    // this.responsibleEditId = usuNrId;
    // this.responsibleRegistrationModalVisible = true;

    const url = this.#router.serializeUrl(
      this.#router.createUrlTree(['usuarios', 'editar', usuNrId]),
    );

    window.open(url, '_blank');
  }

  removeSelectedResponsible(index: number): void {
    if (
      this.userForm.controls.responsibles.controls.length === 1 &&
      this.requiredResponsible
    ) {
      this.#snackbarService.showInfo(
        'É necessário ao menos um responsável para um usuário menor de idade.',
      );
      return;
    }
    this.userForm.controls.responsibles.removeAt(index);
  }

  closeResponsibleModal(): void {
    this.responsibleRegistrationModalVisible = false;
  }

  changeBase64(value: string, fg: FormGroup<AttachmentViewFg>) {
    fg.controls.aneBtAnexo.setValue(value);
    fg.controls.aneBtAnexo.markAsDirty();
    this.userForm.controls.attachments.updateValueAndValidity();
  }

  changeFormat(
    value: AttachmentExtensionEnum,
    fg: FormGroup<AttachmentViewFg>,
  ) {
    fg.controls.aneTxExtensaoAnexo.setValue(value);
    fg.controls.aneTxExtensaoAnexo.markAsDirty();
    this.userForm.controls.attachments.updateValueAndValidity();
  }

  photoChange($event: string, fg: FormGroup<AttachmentViewFg>): void {
    this.previewPhotoForEditingState = undefined;
    this.#photoEditorService
      .open($event, {
        aspectRatio: 3 / 4,
        autoCropArea: 1,
        applyBtnText: 'Salvar',
        closeBtnText: 'Cancelar',
        hideModalHeader: true,
      })
      .subscribe((data) => {
        if (data && data.base64) {
          fg.controls.aneBtAnexo.setValue(data.base64);
          fg.controls.aneBtAnexo.markAsDirty();
        } else {
          fg.controls.aneBtAnexo.setValue(null);
          fg.controls.aneBtAnexo.markAsPristine();
        }
        this.userForm.controls.attachments.updateValueAndValidity();
      });
  }

  #setupChangeFederation(): void {
    this.userForm.controls.basicData.controls.fedNrId.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        notNull(),
        tap(() => {
          this.userForm.controls.basicData.controls.insNrId.reset();
          this.selectedUserInstitution = undefined;
          this.institutionsOptions = { content: [] };
        }),
      )
      .subscribe();
  }

  #syncSelectedFederation(): void {
    const selectedFederationId =
      this.userForm.controls.basicData.controls.fedNrId.value;

    if (!selectedFederationId) {
      this.selectedFederation = {};
      return;
    }

    const foundFederation = this.federationOptions?.content?.find(
      (federation) => federation.fedNrId === selectedFederationId,
    );

    if (foundFederation) {
      this.selectedFederation = foundFederation;
      return;
    }

    if (this.selectedFederation?.fedNrId === selectedFederationId) {
      return;
    }

    this.#federationService
      .getFederationById(selectedFederationId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((federation) => {
        this.selectedFederation = federation;
      });
  }

  onFederationChange(federation: IFederationBasicDataDto | null): void {
    this.selectedFederation = federation || {};
  }

  searchFederationsByName(text: string): void {
    this.federationSearchText = text || '';
    this.#loadFederationsPage(0);
  }

  loadFederationsPaged(page: number): void {
    this.#loadFederationsPage(page);
  }

  #setupChangeInstitution(): void {
    this.userForm.controls.basicData.controls.insNrId.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        notNull(),
        tap((insNrId) => {
          this.selectedUserInstitution =
            this.institutionsOptions?.content?.find(
              (institution) => institution?.insNrId! === Number(insNrId),
            );
        }),
      )
      .subscribe();
  }

  changeSearchInstitutions(searchText: string): void {
    this.institutionFilters$
      .update({
        filters: { insTxNome: searchText },
        pagination: { page: 0, size: 9 },
      })
      .apply();
  }

  findInstituicaoPorCnpj(searchCnpj: string) {
    this.institutionFilters$
      .update({
        filters: { insTxCnpj: searchCnpj },
        pagination: { page: 0, size: 9 },
      })
      .apply();
  }

  findInstituicaoPorInep(searchInep: string) {
    this.institutionFilters$
      .update({
        filters: { insTxCodigoInep: searchInep },
        pagination: { page: 0, size: 9 },
      })
      .apply();
  }

  removeInstitution(): void {
    const birthValue =
      this.userForm.controls.basicData.controls.usuDtNascimento.value;
    const birthDate = this.#parseBirthDateLocal(birthValue);

    if (!birthDate || this.#computeIsUnderage(birthDate)) {
      this.#snackbarService.showWarn(
        'Não é possível remover a instituição de ensino de um atleta menor de idade.',
      );
      return;
    }

    this.#confirmationModalService.openModal({
      modalType: ConfirmationModalType.danger,
      cancelText: 'Cancelar',
      confirmText: 'Remover',
      message: 'Deseja realmente remover a instituição de ensino',
      resourceName: this.selectedUserInstitution?.insTxNome,
      callbackExecuteAction: () => {
        const insNrIdControl =
          this.userForm.controls.basicData.controls.insNrId;
        insNrIdControl.setValue(null);
        insNrIdControl.markAsDirty();
        this.selectedUserInstitution = undefined;
      },
    });
  }

  onPageChange(page: number) {
    this.institutionFilters$
      .update({ pagination: { page: page, size: 9 } })
      .apply();
  }

  #setupChangeEventControl(): void {
    this.eventControl.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((eveNrId) => {
        if (!eveNrId) {
          this.selectedEvent = null;
          return;
        }
        const found = this.eventsOptions?.content?.find(
          (eve) => eve.eveNrId === eveNrId,
        );
        if (found) {
          this.selectedEvent = found;
        } else {
          this.#eventService.getEventById(eveNrId).subscribe((event) => {
            this.selectedEvent = event;
          });
        }
      });

    this.eventControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap((eveNrId) => {
          if (eveNrId === null) {
            this.eventUserValidators = undefined;
            this.userValidationControl.setValue(null);
            return EMPTY;
          }
          return this.#eventService.findValidationsFromEvent(eveNrId!);
        }),
      )
      .subscribe({
        next: (eventValidators) => {
          this.eventUserValidators = eventValidators;

          if (this.responsibleRegistration) {
            this.userValidationControl.setValue(UserType['Responsável']);
            return;
          }

          if (this.userValidationControl.value) {
            this.selectedUserValidator = this.#getValidationFromUserType(
              this.userValidationControl.value,
            ) || {} as IUserFieldsValidatorDto;
            this.#changeUserValidator(this.selectedUserValidator?.uvcNrId!);
          }
        },
      });
  }

  #setupChangeUserValidationControl(): void {
    this.userValidationControl.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((val) => {
        if (!val) {
          this.selectedUserValidation = null;
          return;
        }
        this.selectedUserValidation =
          this.allUserTypeOptions.find((opt) => opt.value === val) || null;
      });

    this.userValidationControl.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (userType) => {
          if (!userType) {
          }

          const isColaborator = userType === UserType.Colaborador;
          if (isColaborator) {
            this.showBankForm = isColaborator;
            this.#setupContaBancariaRequiredFields();
            this.loadBancoList();
            this.setUserTypeFormValue(isColaborator);
          } else {
            this.showBankForm = isColaborator;
          }
          this.selectedUserValidator =
            this.#getValidationFromUserType(userType) || {} as IUserFieldsValidatorDto;
          this.#changeUserValidator(this.selectedUserValidator?.uvcNrId!);
        },
      });
  }

  changeBancoPage(page: number) {
    const filterValue = this.bankListParams.value.filter;
    const pageable = { page: page, size: 10 } as IPageable;
    const filter = { banTxNome: filterValue.banTxNome } as IBancoFilter;
    this.bankListParams.next({ pageable, filter });
  }

  changeAgenciaPage(page: number) {
    const currentFilter = this.agenciaParams.value.filter;
    const pageable = { page: page, size: 10 } as IPageable;

    this.agenciaParams.next({
      pageable,
      filter: currentFilter,
    });
  }

  searchBanco(text: string) {
    const pageable = { page: 0, size: 10 } as IPageable;
    const filter = { banTxNome: text } as IBancoFilter;
    this.bankListParams.next({ pageable, filter });
  }

  searchAgencia(text: string) {
    const pageable = { page: 0, size: 10 } as IPageable;
    const filter = {
      ...this.agenciaParams.value.filter,
      ageTxCodigo: text,
    } as IAgenciaFilter;

    this.agenciaParams.next({ pageable, filter });
  }

  #setupChangeContaBancariaForm() {
    this.loadBancoList();

    this.bankListParams
      .pipe(distinctUntilChanged())
      .subscribe(() => this.loadBancoList());
    const controls = this.contaBancariaForm.controls;
    controls.banNrId.valueChanges
      .pipe(
        distinctUntilChanged(),
        filter((value) => value !== null && value !== undefined),
      )
      .subscribe((value) => {
        const age = controls.ageNrId;
        age.enable();
        age.reset();
        const filter = { banNrId: value } as IAgenciaFilter;
        this.currentBankCod = this.bankList?.content?.find(
          (ban) => ban.banNrId! === filter.banNrId,
        )?.banTxCodigo;
        const pageable = { page: 0, size: 20 } as IPageable;
        this.agenciaParams.next({ filter, pageable });
      });

    this.agenciaParams.pipe(skip(1)).subscribe(() => this.loadAgencias());

    this.contaBancariaForm.valueChanges
      .pipe(
        distinctUntilChanged(),
        tap((value) => {
          if (!value.banNrId) {
            this.currentBankCod = '';
          }
        }),
        map(() => this.hasAnyValue() || this.requiredDadosBancarios.length > 0),
      )
      .subscribe((value) => {
        this.toggleContaValidators(value);
      });
  }

  private hasAnyValue(): boolean {
    return Object.values(this.contaBancariaForm.controls).some((control) => {
      const value = control.value;

      if (value == null) return false;
      if (typeof value === 'string') return value.trim() !== '';

      return true;
    });
  }

  loadAgencias(): void {
    const paramsValue = this.agenciaParams.value;
    const filter = paramsValue.filter;
    const pageable = paramsValue.pageable;
    this.agenciaService.buscarAgencias(filter, pageable).subscribe({
      next: (agencia) => {
        this.agenciaPage = agencia;
      },
      error: (error) => {
        this.#resolveUserFormApiErrors(error);
      },
    });
  }

  changeEventPage(page: number) {
    const filter = this.eventParams.value.filter;
    const pageable = { page: page, size: 10 } as IPageable;
    this.eventParams.next({ pageable, filter });
  }

  searchEvent(text: string) {
    const pageable = { page: 0, size: 10 } as IPageable;
    const filter = { eveTxNome: text } as EventFilter;
    this.eventParams.next({ pageable, filter });
  }

  updateUserValidationPageOptions() {
    this.filteredUserTypeOptions = this.allUserTypeOptions.filter((opt) =>
      opt.label?.toLowerCase().includes(this.userValidationSearchText.toLowerCase())
    );
    const pageSize = 999;
    this.userValidationTotalPages = Math.max(1, Math.ceil(this.filteredUserTypeOptions.length / pageSize));
    if (this.userValidationCurrentPage >= this.userValidationTotalPages) {
      this.userValidationCurrentPage = 0;
    }
    const start = this.userValidationCurrentPage * pageSize;
    this.userValidationPageOptions = this.filteredUserTypeOptions.slice(start, start + pageSize);
  }

  changeUserValidationPage(page: number) {
    this.userValidationCurrentPage = page;
    this.updateUserValidationPageOptions();
  }

  searchUserValidation(text: string) {
    this.userValidationSearchText = text;
    this.userValidationCurrentPage = 0;
    this.updateUserValidationPageOptions();
  }

  #fetchEvents(): void {
    this.eventParams
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap(({ pageable, filter }) =>
          this.#eventService.getAllEventsBasicData(pageable.page, pageable.size, filter)
        )
      )
      .subscribe({
        next: (res) => {
          this.eventsOptions = res;
        },
      });
  }

  addContact(): void {
    console.log('contactAdded');

    const contact = this.fb.group<ControlsOf<ContactForm>>({
      conTxContato: this.fb.control<string | null>(null),
      conTxTipo: this.fb.control(null, Validators.required),
      conBlPrincipal: this.fb.control(false),
      entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
    });

    const conTxContato = contact.controls.conTxContato;
    contact.controls.conTxTipo.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        if (value == ContactTypeEnum.Telefone) {
          conTxContato.setValidators([Validators.required, this.minDigits(11)]);
        } else if (value == ContactTypeEnum.Email) {
          conTxContato.setValidators([Validators.required, Validators.email]);
        } else if (value == ContactTypeEnum.Site) {
          conTxContato.clearValidators();
        }
        conTxContato.updateValueAndValidity({
          emitEvent: false,
        });
      });
    console.log('subscribed');

    this.#subscibeContactValueChanges(contact);
    this.userForm.controls.contacts.push(contact);
    this.userForm.controls.contacts.updateValueAndValidity({
      emitEvent: false,
    });
  }

  removeContact(index: number): void {
    this.userForm.controls.contacts.removeAt(index);
    this.userForm.controls.contacts.updateValueAndValidity();
  }



  onAttachmentAvailableChange(attachment: AttachmentView) {
    const att = this.attachments.find(
      (att) => att.aneTxTipoAnexo === attachment.aneTxTipoAnexo,
    );

    if (att) {
      const attFg = this.fb.group<AttachmentViewFg>({
        entNrId: this.fb.control(null),
        aneNrId: this.fb.control(null),
        tipNrId: this.fb.control(att.tipNrId),
        label: this.fb.control(att.label),
        accepts: this.fb.control(att.accepts),
        aneBtAnexo: this.fb.control(att.aneBtAnexo, Validators.required),
        aneTxExtensaoAnexo: this.fb.control(att.aneTxExtensaoAnexo),
        aneTxTipoAnexo: this.fb.control(att.aneTxTipoAnexo),
        entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
      });
      this.userForm.controls.attachments.push(attFg);
    }

    this.#filterAttachments();
  }

  removeAvailableAttachmentAdded(index: number) {
    this.userForm.controls.attachments.removeAt(index);
    this.#filterAttachments();
  }

  removeAttachmentFoto(): void {
    const attachmentFoto =
      this.userForm.controls.attachments.controls.findIndex(
        (fg) => fg.controls.aneTxTipoAnexo.value === AttachmentTypeEnum.FOTO,
      );

    if (attachmentFoto !== -1) {
      this.userForm.controls.attachments.removeAt(attachmentFoto);
    }
    this.#filterAttachments();
  }

  showRemoveAttachmentField(fg: FormGroup<AttachmentViewFg>): boolean {
    return !this.requiredAttachments.includes(
      fg.controls.aneTxTipoAnexo.value!,
    );
  }

  #setupAttachmentTypesIds(): void {
    attachments.forEach((att) => {
      const attachmentType = this.attachmentTypeOptions?.content?.find(
        (attType) => attType.tipTxDescricao === att.aneTxTipoAnexo,
      );

      att.tipNrId = attachmentType?.tipNrId ?? null;
    });
  }

  changeUserValidator(validator: IUserFieldsValidatorDto | null | undefined): void {
    this.requiredAttachments = [];
    this.requiredDocuments = [];
    this.requiredContacts = [];
    this.#removeBasicDataRequiredValidators();
    this.#removeAddressRequiredValidators();

    const uvcNrId = validator?.uvcNrId;
    if (uvcNrId) {
      this.selectedUserValidator = validator!;
      this.#changeUserValidator(uvcNrId);
    }
  }

  #changeUserValidator(uvcNrId?: number): void {
    this.requiredAttachments = [];
    this.requiredDocuments = [];
    this.requiredContacts = [];
    this.requiredDadosBancarios = [];
    this.#removeBasicDataRequiredValidators();
    this.#removeAddressRequiredValidators();
    this.#removeContactsRequiredValidators();
    this.#setupRequiredDocuments();
    //this.#removeDocumentsRequiredValidators();

    if (uvcNrId) {
      this.requiredAttachments =
        this.selectedUserValidator?.uvcListAnexos ?? [];
      this.requiredDocuments =
        this.selectedUserValidator?.uvcListDocumentos ?? [];
      this.requiredContacts = this.selectedUserValidator?.uvcListContatos ?? [];

      this.requiredDadosBancarios =
        this.selectedUserValidator?.uvcListDadosBancarios ?? [];

      if (this.editUserExternalData?.externalTypeEdit == UserType.Colaborador) {
        this.setUserTypeFormValue(true);
        this.showBankForm = true;
        this.loadBancoList();
      }

      // Remove slots de contato criados só para o papel anterior (não persistidos).
      // Contatos já salvos (entNrId) permanecem na lista.
      this.#pruneContactsNotInRequired(this.requiredContacts);

      // Mesma ideia dos contatos: anexos dinâmicos do papel anterior somem ao trocar.
      this.#pruneAttachmentsNotInRequired(this.requiredAttachments);

      this.#setupControlRequiredFields();
      this.#setupRequiredContacts();
      this.#setupRequiredDocuments();
      this.#setupRequiredAttachments();
      this.#setupRequiredBankData();
    }
  }

  #setupRequiredBankData() {
    if (this.requiredDadosBancarios.length > 0) {
      this.toggleContaValidators(true);
    } else {
      this.toggleContaValidators(false);
    }
  }

  #removeBasicDataRequiredValidators(): void {
    const excludedFields = ['usuTxNome', 'fedNrId', 'usuDtNascimento'];
    Object.keys(this.userForm.controls.basicData.controls).forEach((key) => {
      if (!excludedFields.includes(key)) {
        this.userForm.controls.basicData
          .get(key)
          ?.removeValidators(Validators.required);
        this.userForm.controls.basicData
          .get(key)
          ?.updateValueAndValidity({ emitEvent: false });
      }
    });
    this.#ensureIntrinsicLengthValidators();
  }

  #removeAddressRequiredValidators(): void {
    const excludedFields = ['cidNrId', 'paiNrId', 'estNrId'];
    Object.keys(this.userForm.controls.address.controls).forEach((key) => {
      if (!excludedFields.includes(key)) {
        this.userForm.controls.address
          .get(key)
          ?.removeValidators(Validators.required);
        this.userForm.controls.address
          .get(key)
          ?.updateValueAndValidity({ emitEvent: false });
      }
    });
    this.#ensureIntrinsicLengthValidators();
  }

  /** Mantém validação de tamanho do INEP (12) e CEP (8–9) ao trocar papel no evento. */
  #ensureIntrinsicLengthValidators(): void {
    const inep = this.userForm.controls.basicData.controls.usuTxCodigoInep;
    inep.removeValidators([Validators.minLength(12), Validators.maxLength(12)]);
    inep.addValidators([Validators.minLength(12), Validators.maxLength(12)]);
    inep.updateValueAndValidity({ emitEvent: false });

    const cep = this.userForm.controls.address.controls.logTxCep;
    if (cep) {
      cep.removeValidators([Validators.minLength(8), Validators.maxLength(9)]);
      cep.addValidators([Validators.minLength(8), Validators.maxLength(9)]);
      cep.updateValueAndValidity({ emitEvent: false });
    }
  }

  #removeContactsRequiredValidators() {
    const contactsFa = this.userForm.controls.contacts;

    // Nunca mutar `contacts.controls = [...]` diretamente: isso pode corromper o estado do FormArray.
    // A ideia aqui é apenas remover obrigatoriedade (required) e manter os registros já existentes.
    contactsFa.controls.forEach((fg) => {
      fg.controls.conTxTipo.clearValidators();
      fg.controls.conTxContato.clearValidators();

      // Mantém validações “intrínsecas” por tipo (sem required)
      const type = fg.controls.conTxTipo.value;
      if (type === ContactTypeEnum.Email) {
        fg.controls.conTxContato.setValidators([Validators.email]);
      } else if (type === ContactTypeEnum.Telefone) {
        fg.controls.conTxContato.setValidators([this.minDigits(11)]);
      }

      fg.controls.conTxTipo.updateValueAndValidity({ emitEvent: false });
      fg.controls.conTxContato.updateValueAndValidity({ emitEvent: false });
      fg.updateValueAndValidity({ emitEvent: false });
    });

    // Garante ao menos um Email para o usuário não ficar sem campo visível
    const hasEmail = contactsFa.controls.some(
      (fg) => fg.controls.conTxTipo.value === ContactTypeEnum.Email,
    );
    if (!hasEmail) {
      const email = this.fb.group<ControlsOf<ContactForm>>({
        entNrId: this.fb.control(null),
        conTxContato: this.fb.control<string | null>(null, Validators.email),
        conTxTipo: this.fb.control(ContactTypeEnum.Email),
        conBlPrincipal: this.fb.control(true),
        entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
      });
      contactsFa.push(email);
    }

    contactsFa.updateValueAndValidity({ emitEvent: false });
  }

  /**
   * Ao trocar de papel, remove do FormArray apenas contatos ainda não salvos
   * cujo tipo não é exigido pelo validador atual. Evita deixar telefone/extras
   * “fantasma” do papel anterior (ex.: Responsável → Atleta).
   */
  #pruneContactsNotInRequired(requiredTypes: ContactTypeEnum[]): void {
    const requiredSet = new Set(requiredTypes);
    const fa = this.userForm.controls.contacts;

    for (let i = fa.length - 1; i >= 0; i--) {
      const fg = fa.at(i);
      const entNrId = fg.controls.entNrId?.value;
      if (entNrId != null) continue;

      const tipo = fg.controls.conTxTipo.value;
      if (tipo != null && requiredSet.has(tipo)) continue;

      fa.removeAt(i);
    }

    fa.updateValueAndValidity({ emitEvent: false });
  }

  /**
   * Remove do FormArray anexos ainda não persistidos cujo tipo não é exigido pelo
   * validador atual (slots criados para outro papel).
   */
  #pruneAttachmentsNotInRequired(requiredTypes: AttachmentTypeEnum[]): void {
    const requiredSet = new Set(requiredTypes);
    const fa = this.userForm.controls.attachments;

    for (let i = fa.length - 1; i >= 0; i--) {
      const fg = fa.at(i);
      const entNrId = fg.controls.entNrId?.value;
      const aneNrId = fg.controls.aneNrId?.value;
      if (entNrId != null || aneNrId != null) continue;

      const tipo = fg.controls.aneTxTipoAnexo.value;
      if (tipo != null && requiredSet.has(tipo)) continue;

      fa.removeAt(i);
    }

    fa.updateValueAndValidity({ emitEvent: false });
  }

  #setupControlRequiredFields(): void {
    if (this.selectedUserValidator?.uvcListCampos) {
      for (const fieldEnum of this.selectedUserValidator?.uvcListCampos) {
        if (fieldEnum !== UserBasicDataEnum.CODIGO_INEP) {
          const fieldName = userBasicDataFieldReference[fieldEnum];
          const fieldControl =
            this.userForm?.controls?.basicData?.get(fieldName);
          fieldControl?.addValidators(Validators.required);
          fieldControl?.updateValueAndValidity({ emitEvent: false });
        }
      }
    }

    if (this.selectedUserValidator?.uvcListLogradouro) {
      for (const fieldEnum of this.selectedUserValidator?.uvcListLogradouro) {
        const fieldName = userAddressFieldReference[fieldEnum];
        const fieldControl = this.userForm?.controls?.address?.get(fieldName);

        fieldControl?.addValidators(Validators.required);
        fieldControl?.updateValueAndValidity({ emitEvent: false });
      }
    }

    this.#ensureIntrinsicLengthValidators();
    this.#syncInepRequiredValidator();
  }

  #setupContaBancariaRequiredFields() {
    if (
      this.selectedUserValidator?.uvcListDadosBancarios &&
      this.showBankForm
    ) {
      const controls = this.userForm?.controls?.contaBancariaForm.controls;
      controls.banNrId.setValidators(Validators.required);
      controls.ageNrId.setValidators(Validators.required);
      controls.cobTxNumeroConta.setValidators([
        Validators.required,
        Validators.maxLength(20),
      ]);
      controls.cobTxTipoConta.setValidators([Validators.required]);
      this.userForm?.controls?.contaBancariaForm.updateValueAndValidity({
        emitEvent: false,
      });
    }
  }

  #setupControlRequiredResponsible(): void {
    this.userForm.controls.basicData.controls.usuDtNascimento.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((dateOfBirth) => {
        if (dateOfBirth == null) {
          this.requiredResponsible = false;
        } else {
          this.#checkIfUnderage(dateOfBirth);
        }
        this.#syncInepRequiredValidator();
      });
  }

  /**
   * INEP: sempre valida 12 caracteres; obrigatório (borda azul) somente se o
   * papel/validador do evento exigir CODIGO_INEP. A data de nascimento não
   * altera essa obrigatoriedade.
   */
  #syncInepRequiredValidator(): void {
    const inep = this.userForm.controls.basicData.controls.usuTxCodigoInep;
    const hasRoleSelected = !!this.selectedUserValidator;
    const roleRequiresInep =
      this.selectedUserValidator?.uvcListCampos?.includes(
        UserBasicDataEnum.CODIGO_INEP,
      ) ?? false;

    const shouldRequireInep = hasRoleSelected && roleRequiresInep;

    inep.setValidators([
      Validators.minLength(12),
      Validators.maxLength(12),
      ...(shouldRequireInep ? [Validators.required] : []),
    ]);
    this.inepShowsRequiredBorder = shouldRequireInep;
    inep.updateValueAndValidity({ emitEvent: false });
    this.#cdr.detectChanges();
  }

  #parseBirthDateLocal(value: string | Date | null | undefined): Date | null {
    if (value == null) {
      return null;
    }
    if (value instanceof Date) {
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }
    const parts = String(value).split('-');
    if (parts.length !== 3) {
      return null;
    }
    const year = Number.parseInt(parts[0], 10);
    const month = Number.parseInt(parts[1], 10) - 1;
    const day = Number.parseInt(parts[2], 10);
    if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) {
      return null;
    }
    return new Date(year, month, day);
  }

  #computeIsUnderage(birthDate: Date): boolean {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();

    const hasHadBirthdayThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() >= birthDate.getDate());

    if (!hasHadBirthdayThisYear) {
      age--;
    }

    return age < 18;
  }

  #checkIfUnderage(dateOfBirth: string | Date) {
    const birthDate = this.#parseBirthDateLocal(dateOfBirth);
    this.requiredResponsible =
      birthDate != null && this.#computeIsUnderage(birthDate);
  }

  putUserAdressToGuardian(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (!isChecked) {
      this.userForm.controls.address.reset();
      return;
    }

    this.userForm.controls.address.controls.logTxCep!.setValue(
      this.addressFg?.controls.logTxCep!.value ?? null,
    );

    this.userForm.controls.address.patchValue(
      {
        logTxBairro: this.addressFg?.controls.logTxBairro.value ?? null,
        logTxLogradouro: this.addressFg?.controls.logTxLogradouro.value ?? null,
        logTxComplemento:
          this.addressFg?.controls.logTxComplemento.value ?? null,
        logNrNumero: this.addressFg?.controls.logNrNumero.value ?? null,
      },
      { emitEvent: false },
    );
  }

  get isEdit(): boolean {
    return !!this.usuNrId;
  }

  get attachmentFoto(): FormGroup<AttachmentViewFg> | undefined {
    return this.userForm.controls.attachments.controls.find(
      (fg) => fg.controls.aneTxTipoAnexo.value === AttachmentTypeEnum.FOTO,
    );
  }

  get attachmentFotoIsRequired(): boolean {
    return (
      this.selectedUserValidator?.uvcListAnexos?.includes(
        AttachmentTypeEnum.FOTO,
      ) ?? false
    );
  }

  get showRemoveInstitutionButton(): boolean {
    if (!this.selectedUserInstitution) return false;

    const birthValue =
      this.userForm.controls.basicData.controls.usuDtNascimento.value;
    const birthDate = this.#parseBirthDateLocal(birthValue);

    if (!birthDate) return false;

    return !this.#computeIsUnderage(birthDate);
  }

  #filterAttachments(): void {
    this.filteredAttachments = this.attachments.filter(
      (att) =>
        !this.userForm.controls.attachments.controls.some(
          (fg) => fg.controls.aneTxTipoAnexo.value === att.aneTxTipoAnexo,
        ),
    );
  }

  #subscibeContactValueChanges(contact: FormGroup<ControlsOf<ContactForm>>) {
    const conTxContato = contact.controls.conTxContato;
    conTxContato.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        debounceTime(500),
        filter((value) => value !== null && value !== ''),
        filter(() => contact.valid),
        switchMap((value) => {
          const conTxTipo = contact.controls.conTxTipo.value;
          console.log('contxTipo', conTxTipo);
          if (conTxTipo == null) {
            return of(null);
          }
          switch (conTxTipo) {
            case ContactTypeEnum.Email: {
              this.loadingEmailValidation = true;
              return this.#fetchValidation(
                value!,
                TipoCampoValidacaoEnum.EMAIL,
              ).pipe(
                catchError((err: ResponseDto<BodyErrorDto>) => {
                  console.log();
                  if (err.response.message.includes('inválido')) {
                    this.invalidEmails.push(value!);
                  } else {
                    this.existingEmails.push(value!);
                  }
                  this.#resolveUserFormApiErrors(err);
                  return of(null);
                }),
              );
            }
            case ContactTypeEnum.Telefone: {
              if (value?.length == 11) {
                this.loadingPhoneValidation = true;
                return this.#fetchValidation(
                  value,
                  TipoCampoValidacaoEnum.TELEFONE,
                ).pipe(
                  catchError((err) => {
                    this.existingPhones.push(value);
                    this.#resolveUserFormApiErrors(err);
                    return of(null);
                  }),
                );
              }
              return of(null);
            }
            case ContactTypeEnum.Site: {
              return of(null);
            }
          }
        }),
      )
      .subscribe(() => {
        this.loadingPhoneValidation = false;
        this.loadingEmailValidation = false;
      });
  }

  #fetchValidation(
    campo: string,
    tipoCampoValidacaoEnum: TipoCampoValidacaoEnum,
  ): Observable<ValidadorDocumentosEhContatosDto> {
    return this.#documentValidationService.getValidation(
      campo,
      tipoCampoValidacaoEnum,
      this.usuNrId || null,
    );
  }

  #setupRequiredContacts(): void {
    const hasEmail = this.userForm.controls.contacts.controls.some(
      (ctt) => ctt.controls.conTxTipo.value === ContactTypeEnum.Email,
    );

    if (this.selectedUserValidator) {
      // Garante sempre pelo menos um Email (obrigatório ou não, dependendo do papel)
      if (!hasEmail) {
        const email = this.fb.group<ControlsOf<ContactForm>>({
          entNrId: this.fb.control(null),
          conTxContato: this.fb.control<string | null>(null, Validators.email),
          conTxTipo: this.fb.control(
            ContactTypeEnum.Email,
            Validators.required,
          ),
          conBlPrincipal: this.fb.control(true),
          entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
        });
        this.userForm.controls.contacts.push(email);
        this.#subscibeContactValueChanges(email);
      }

      this.requiredContacts
        .filter((cttReq) => cttReq !== ContactTypeEnum.Email)
        .forEach((contactType) => {
          const hasContact = this.userForm.controls.contacts.controls.some(
            (ctt) => ctt.controls.conTxTipo.value === contactType,
          );
          if (!hasContact) {
            const contact = this.fb.group<ControlsOf<ContactForm>>({
              entNrId: this.fb.control(null),
              conTxContato: this.fb.control(null, [Validators.required]),
              conTxTipo: this.fb.control(contactType, Validators.required),
              conBlPrincipal: this.fb.control(false),
              entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
            });
            this.userForm.controls.contacts.push(contact);
            this.#subscibeContactValueChanges(contact);
          }
        });

      this.#updateRequiredContacts();
      return;
    }

    if (!hasEmail) {
      const email = this.fb.group<ControlsOf<ContactForm>>({
        entNrId: this.fb.control(null),
        conTxContato: this.fb.control(null, Validators.email),
        conTxTipo: this.fb.control(ContactTypeEnum.Email),
        conBlPrincipal: this.fb.control(true),
        entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
      });

      this.userForm.controls.contacts.push(email);
      this.#subscibeContactValueChanges(email);
    }

    this.userForm.controls.contacts.updateValueAndValidity();
  }

  private updatingRequiredContacts = false;
  #updateRequiredContacts(): void {
    if (this.updatingRequiredContacts) return;
    this.updatingRequiredContacts = true;

    this.requiredContacts.forEach((contactType) => {
      const contactFg = this.userForm.controls.contacts.controls.find(
        (fg) => fg.controls.conTxTipo.value === contactType,
      );
      if (contactFg) {
        contactFg.controls.conTxTipo.setValidators([Validators.required]);
        contactFg.controls.conTxContato.setValidators([Validators.required]);
      }
      if (contactFg?.controls.conTxTipo.value == 'EMAIL') {
        contactFg.controls.conTxContato.setValidators([
          Validators.required,
          Validators.email,
        ]);
      }
      if (contactFg?.controls.conTxTipo.value == 'TELEFONE') {
        contactFg.controls.conTxContato.setValidators([
          Validators.required,
          this.minDigits(11),
        ]);
      }
      contactFg?.controls.conTxContato.updateValueAndValidity({
        emitEvent: false,
      });
      contactFg?.controls.conTxTipo.updateValueAndValidity({
        emitEvent: false,
      });
      contactFg?.updateValueAndValidity({ emitEvent: false });
    });
    this.userForm.controls.contacts.updateValueAndValidity({
      emitEvent: false,
    });
    this.updatingRequiredContacts = false;
  }

  minDigits(min: number) {
    return (control: AbstractControl) => {
      if (!control.value) return null;
      const digits = control.value.replace(/\D/g, '');
      return digits.length >= min ? null : { minDigits: true };
    };
  }

  #setupRequiredDocuments(): void {
    let documents = this.documents;
    if (this.userForm.controls.documents.controls.length > 0) {
      this.checked = true;
      this.userForm.controls.documents.controls.forEach((fg, i) => {
        const containsInRequireds = this.requiredDocuments.includes(
          fg.controls.docTxTipo.value!,
        );
        let validators = containsInRequireds ? [Validators.required] : [];
        validators?.push(Validators.minLength(5));
        if (fg.controls.docTxTipo.value === DocumentTypeEnum.CPF) {
          validators?.pop();
          validators?.push(Validators.minLength(11));
        }

        fg.controls.docTxDocumento.setValidators(validators);
        fg.controls.docTxDocumento.updateValueAndValidity({ emitEvent: false });

        if (fg.controls.docTxTipo.value === DocumentTypeEnum.RG) {
          fg.controls.docTxOrgaoExpeditor.setValidators([
            Validators.minLength(3),
            Validators.maxLength(100),
          ]);
          fg.controls.docTxOrgaoExpeditor.updateValueAndValidity({
            emitEvent: false,
          });
        }

        this.#setDocumentControlDeleteOnChange(fg);
        fg.updateValueAndValidity({ emitEvent: false });
      });
      this.userForm.controls.documents.updateValueAndValidity({
        emitEvent: false,
      });

      return;
    }

    documents.forEach((document) => {
      const docFg = this.fb.group<DocumentViewFg>({
        entNrId: this.fb.control(null),
        label: this.fb.control(document.label),
        mask: this.fb.control(document.mask),
        placeholder: this.fb.control(document.placeholder),
        docTxDocumento: this.fb.control(document.docTxDocumento),
        docTxTipo: this.fb.control(document.docTxTipo),
        docTxOrgaoExpeditor: this.fb.control(document.docTxOrgaoExpeditor),
        entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
      });

      if (docFg.controls.docTxTipo.value === DocumentTypeEnum.RG) {
        const rgControl = docFg.controls.docTxDocumento;
        const orgaoExpeditorControl = docFg.controls.docTxOrgaoExpeditor;
        orgaoExpeditorControl.setValidators([Validators.minLength(3)]);

        rgControl.valueChanges
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((valorRg) => {
            if (valorRg && valorRg !== '') {
              if (!orgaoExpeditorControl.hasValidator(Validators.required)) {
                orgaoExpeditorControl.addValidators(Validators.required);
              }
            } else {
              orgaoExpeditorControl.removeValidators(Validators.required);
            }
            orgaoExpeditorControl.updateValueAndValidity({ emitEvent: false });
            docFg.updateValueAndValidity({ emitEvent: false });
          });
      }

      if (docFg.controls.docTxTipo.value === DocumentTypeEnum.CPF) {
        const cpfControl = docFg.controls.docTxDocumento;
        cpfControl.valueChanges
          .pipe(
            takeUntil(this.unsubscribe$),
            distinctUntilChanged(),
            filter(
              (value) => value != null && value != undefined && value != '',
            ),
            tap((value) => {
              if (value?.length !== 11) {
                this.cpfControlMessage = null;
              }
            }),
            filter((value) => value?.length == 11),
            switchMap((value) => {
              this.cpfValidationLoading = true;
              return this.#fetchValidation(
                value!,
                TipoCampoValidacaoEnum.CPF,
              ).pipe(
                catchError((res) => {
                  this.cpfValidationLoading = false;
                  this.#resolveUserFormApiErrors(res);
                  this.cpfControlMessage = 'CPF já existe.';
                  return of(null);
                }),
              );
            }),
          )
          .subscribe((result) => {
            this.cpfValidationLoading = false;
            this.cpfControlMessage = null;
            if (result?.usuNrId !== null) {
              this.cpfControlMessage = 'CPF já existe.';
            }
            if (result?.isMesmaFederacao) {
              this.cpfRedirectData = result;
              this.openModalCpfValidation = true;
            }
          });
      }

      this.userForm.controls.documents.controls.push(docFg);
      this.userForm.controls.documents.updateValueAndValidity({
        emitEvent: false,
      });
    });

    this.userForm.controls.documents.updateValueAndValidity({
      emitEvent: true,
    });
  }

  #setDocumentControlDeleteOnChange(
    documentControl: FormGroup<DocumentViewFg>,
  ): void {
    const docControl = documentControl.controls.docTxDocumento;
    const metadataControl = documentControl.controls.entTxMetadado;
    const originalDocumentValue = docControl.value;

    docControl.valueChanges
      .pipe(takeUntil(this.unsubscribe$), distinctUntilChanged())
      .subscribe((value) => {
        if (this.patchingDocuments) return;

        if (
          metadataControl?.value === MetadataPutEnum.INALTERADO &&
          docControl.dirty &&
          value !== originalDocumentValue &&
          (value == null || value?.trim() == '')
        ) {
          metadataControl.setValue(MetadataPutEnum.DELETADO, {
            emitEvent: false,
          });
        }
      });
  }

  handleEditExistingUserWithCpf() {
    this.#router
      .navigate(['usuarios', 'editar', this.cpfRedirectData?.usuNrId])
      .then();
  }
  handleContinueWithNewCpf() {
    if (!this.#router.url.includes('criar')) {
      this.#router.navigate(['usuarios', 'criar']).then();
    } else {
      this.userForm.controls.documents.controls
        .find((doc) => doc.controls.docTxTipo.value === DocumentTypeEnum.CPF)
        ?.controls.docTxDocumento.reset();
      this.cpfControlMessage = null;
      this.openModalCpfValidation = false;
    }
  }
  closeModalCpfValidation(event: boolean) {
    this.openModalCpfValidation = event;
  }

  #setupRequiredAttachments(
    userSavedAttachments?: AttachmentTypeEnum[],
    callback?: () => void,
  ): void {
    let attachments = this.attachments;

    if (userSavedAttachments?.length! > 0) {
      //console.log('entrada 0');

      if (!this.selectedUserValidator) {
        attachments = this.attachments.filter((att) =>
          userSavedAttachments?.includes(att.aneTxTipoAnexo),
        );
        this.userForm.controls.attachments.clear();
        attachments.forEach((attachment) => {
          const attFg = this.fb.group<AttachmentViewFg>({
            entNrId: this.fb.control(null),
            aneNrId: this.fb.control(null),
            tipNrId: this.fb.control(attachment.tipNrId),
            label: this.fb.control(attachment.label),
            accepts: this.fb.control(attachment.accepts),
            aneBtAnexo: this.fb.control(attachment.aneBtAnexo),
            aneTxExtensaoAnexo: this.fb.control(attachment.aneTxExtensaoAnexo),
            aneTxTipoAnexo: this.fb.control(attachment.aneTxTipoAnexo),
            entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
          });
          this.userForm.controls.attachments.controls.push(attFg);
          this.userForm.controls.attachments.updateValueAndValidity();
        });
      } else {
        //console.log('entrada 1');
        attachments = this.attachments.filter((att) =>
          userSavedAttachments?.includes(att.aneTxTipoAnexo),
        );
        this.userForm.controls.attachments.clear();
        attachments.forEach((attachment) => {
          const attFg = this.fb.group<AttachmentViewFg>({
            entNrId: this.fb.control(null),
            aneNrId: this.fb.control(null),
            tipNrId: this.fb.control(attachment.tipNrId),
            label: this.fb.control(attachment.label),
            accepts: this.fb.control(attachment.accepts),
            aneBtAnexo: this.fb.control(attachment.aneBtAnexo),
            aneTxExtensaoAnexo: this.fb.control(attachment.aneTxExtensaoAnexo),
            aneTxTipoAnexo: this.fb.control(attachment.aneTxTipoAnexo),
            entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
          });
          this.userForm.controls.attachments.controls.push(attFg);
          this.userForm.controls.attachments.updateValueAndValidity();
        });

        attachments = this.attachments.filter((att) =>
          this.requiredAttachments.includes(att.aneTxTipoAnexo),
        );
        attachments.forEach((attachment) => {
          const hasAttFg = this.userForm.controls.attachments.controls.some(
            (fg) =>
              fg.controls.aneTxTipoAnexo.value === attachment.aneTxTipoAnexo,
          );

          if (!hasAttFg) {
            const attFg = this.fb.group<AttachmentViewFg>({
              entNrId: this.fb.control(null),
              aneNrId: this.fb.control(null),
              tipNrId: this.fb.control(attachment.tipNrId),
              label: this.fb.control(attachment.label),
              accepts: this.fb.control(attachment.accepts),
              aneBtAnexo: this.fb.control(attachment.aneBtAnexo),
              aneTxExtensaoAnexo: this.fb.control(
                attachment.aneTxExtensaoAnexo,
              ),
              aneTxTipoAnexo: this.fb.control(attachment.aneTxTipoAnexo),
              entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
            });
            this.userForm.controls.attachments.controls.push(attFg);
            this.userForm.controls.attachments.updateValueAndValidity();
          }
        });
      }
    } else if (this.selectedUserValidator) {
      //aqui entra assim que seleciona um validador
      //quando retira nao faz nada
      //console.log('entrada 2');
      attachments = this.attachments.filter((att) =>
        this.requiredAttachments.includes(att.aneTxTipoAnexo),
      );

      attachments.forEach((attachment) => {
        const hasAttFg = this.userForm.controls.attachments.controls.some(
          (fg) =>
            fg.controls.aneTxTipoAnexo.value === attachment.aneTxTipoAnexo,
        );

        if (!hasAttFg) {
          const attFg = this.fb.group<AttachmentViewFg>({
            entNrId: this.fb.control(null),
            aneNrId: this.fb.control(null),
            tipNrId: this.fb.control(attachment.tipNrId),
            label: this.fb.control(attachment.label),
            accepts: this.fb.control(attachment.accepts),
            aneBtAnexo: this.fb.control(attachment.aneBtAnexo),
            aneTxExtensaoAnexo: this.fb.control(attachment.aneTxExtensaoAnexo),
            aneTxTipoAnexo: this.fb.control(attachment.aneTxTipoAnexo),
            entTxMetadado: this.fb.control(MetadataPutEnum.CRIADO),
          });
          this.userForm.controls.attachments.controls.push(attFg);
          this.userForm.controls.attachments.updateValueAndValidity();
        }
      });
    } else {
      //console.log('entrada 3');
      attachments = [];
    }

    if (this.userForm.controls.attachments.controls.length > 0) {
      this.userForm.controls.attachments.controls.forEach((fg) => {
        const tipo = fg.controls.aneTxTipoAnexo.value;
        if (tipo == null || !this.requiredAttachments.includes(tipo)) {
          fg.controls.aneBtAnexo.clearValidators();
          fg.controls.aneTxTipoAnexo.clearValidators();
          fg.controls.aneBtAnexo.updateValueAndValidity({ emitEvent: false });
          fg.controls.aneTxTipoAnexo.updateValueAndValidity({
            emitEvent: false,
          });
          fg.updateValueAndValidity({ emitEvent: false });
        }
      });

      this.requiredAttachments.forEach((att) => {
        const attFg = this.userForm.controls.attachments.controls.find(
          (fg) => fg.controls.aneTxTipoAnexo.value === att,
        );
        if (attFg) {
          attFg.controls.aneBtAnexo.setValidators(Validators.required);
          attFg.controls.aneTxTipoAnexo.setValidators(Validators.required);
          attFg.controls.aneBtAnexo.updateValueAndValidity({
            emitEvent: false,
          });
          attFg.controls.aneTxTipoAnexo.updateValueAndValidity({
            emitEvent: false,
          });
        }
      });

      this.userForm.controls.attachments.updateValueAndValidity({
        emitEvent: false,
      });
    }

    callback && callback();

    this.#filterAttachments();
  }

  containsInRequiredAttachments(
    attachmentFg: FormGroup<AttachmentViewFg>,
  ): boolean {
    return this.requiredAttachments.includes(
      attachmentFg.controls.aneTxTipoAnexo.value!,
    );
  }

  showResponsibleModal(): void {
    this.responsibleRegistrationModalVisible = true;
    this.selectedEventForResponsibleValidation = this.eventControl.value!;
    this.selectedValidationForResponsibleValidation =
      this.selectedUserValidator;
  }

  changeModalState(state: boolean): void {
    this.responsibleRegistrationModalVisible = state;
  }

  temCargoEspecifico(): boolean {
    const userSaved =
      !!this.userForm.controls.basicData.controls.entNrId?.value;
    const userContainsPositonSaved = !!(
      this.currentUserStoredData?.carNrId !== null
    );
    return userSaved && userContainsPositonSaved;
  }

  generateNewPassword() {
    if (this.currentUserStoredData && this.currentUserStoredData.usuNrId) {
      this.#loadingService.activate();
      this.#userService
        .generateNewPasswordForUser(this.currentUserStoredData.usuNrId)
        .subscribe({
          next: (response) => {
            this.#loadingService.deactivate();
            this.#snackbarService.showSuccess(
              'Senha gerada com sucesso e enviada por e-mail.',
            );
          },
          error: (err) => {
            this.#loadingService.deactivate();
            this.#resolveUserFormApiErrors(err);
          },
        });
    } else {
      console.error('Usuário não possui ID válido.');
    }
  }

  #getValidationFromUserType(
    userType: UserType | null,
  ): IUserFieldsValidatorDto | undefined {
    if (!userType) return undefined;
    switch (userType) {
      case UserType.Dirigente:
        return this.eventUserValidators?.eveNrEvpValidador;
      case UserType.Colaborador:
        return this.eventUserValidators?.eveNrEvdValidador;
      case UserType['Comissão Técnica']:
        return this.eventUserValidators?.eveNrEvcValidador;
      case UserType.Responsável:
        return this.eventUserValidators?.eveNrRespValidador;
      case UserType.Atleta:
        return this.eventUserValidators?.eveNrAtlValidador;
      default:
        return undefined;
    }
  }

  show() {
    console.log(this.userForm.controls.basicData);
    console.log(this.userForm.controls.address);
    console.log(this.userForm.controls.contacts);
    console.log(this.userForm.controls.documents);
    console.log(this.userForm.controls.attachments);
  }

  navigateToUserList(): void {
    if (this.responsibleRegistration) {
      this.usuNrId = undefined;
      this.cancelResponsibleEmit.emit();
      this.userForm.reset();
      return;
    } else {
      this.#router.navigate(['usuarios']);
    }
  }

  openUseTerms(): void {
    this.openModalUseTerms = true;
  }

  toggleModalUseTerms(event: boolean) {
    this.openModalUseTerms = event;
  }

  setTerm() {
    this.userForm.controls.termoUsoForm.patchValue({
      terNrId: this.useTerms?.terNrId,
    });
  }

  #setupChangeFedNrId(): void {
    this.userForm.controls.basicData.controls.fedNrId.valueChanges
      .pipe(notNull(), takeUntil(this.unsubscribe$))
      .subscribe((fedNrId) => {
        this.userForm.controls.basicData.controls.insNrId.reset();
        this.selectedUserInstitution = undefined;
        this.institutionsOptions = { content: [] };
        this.institutionFilters$.update({ filters: { fedNrId } }).apply();
      });
  }

  private cleanTrashFormDocuments(form: DocumentForm[]) {
    form.forEach((doc) => {
      const fetchedDocFg = this.userForm.controls.documents.controls.find(
        (docFg) => docFg.controls.entNrId?.value === doc.entNrId,
      );
      fetchedDocFg?.controls.entNrId?.reset();
      fetchedDocFg?.controls.docTxDocumento?.reset();
      fetchedDocFg?.controls.entTxMetadado?.reset();
    });
  }

  private cleanTrashFormContacts(form: ContactForm[]) {
    form.forEach((doc) => {
      const fetchedDocFg = this.userForm.controls.contacts.controls.find(
        (docFg) => docFg.controls.entNrId?.value === doc.entNrId,
      );
      fetchedDocFg?.controls.entNrId?.reset();
      fetchedDocFg?.controls.conTxContato?.reset();
      fetchedDocFg?.controls.entTxMetadado?.reset();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.searchInstitutionSubject.next('');
    this.searchInstitutionSubject.complete();
  }

  handleCancelClick(): void {
    if (this.isModal) {
      this.cancelModal.emit();
    } else {
      this.navigateToUserList();
    }
  }
  printForm(): void {
    const invalids: Array<{
      path: string;
      errors: unknown;
      value?: unknown;
      status: string;
    }> = [];

    const walk = (control: AbstractControl, path: string): void => {
      if (!control.invalid) return;

      const isGroup = control instanceof FormGroup;
      const isArray = control instanceof FormArray;

      if (!isGroup && !isArray) {
        invalids.push({
          path: path || '<root>',
          errors: control.errors,
          value: control.value,
          status: control.status,
        });
        return;
      }

      if (control.errors) {
        invalids.push({
          path: path || '<root>',
          errors: control.errors,
          status: control.status,
        });
      }

      if (isGroup) {
        Object.entries(control.controls).forEach(([k, c]) =>
          walk(c, path ? `${path}.${k}` : k),
        );
      } else if (isArray) {
        control.controls.forEach((c, i) => walk(c, `${path}[${i}]`));
      }
    };

    console.log(
      'userForm.status =',
      this.userForm.status,
      '| invalid =',
      this.userForm.invalid,
      '| rootErrors =',
      this.userForm.errors,
    );
    walk(this.userForm, '');
    console.table(invalids);
  }
}
